<template>
  <div class="pbl">
    <div
      class="pdfCon"
      ref="reportPdf"
      v-loading="loading"
      element-loading-text="小可正在生成报告，请稍等。"
      element-loading-spinner="el-icon-loading"
    >
      <div class="AiBtn" v-if="isDown">
        <div style="display: flex;">
          <el-button type="primary" size="small" @click="getAiAnalysisCon3"
            >AI分析</el-button
          >
          <el-button type="primary" @click="isGetPdf" size="small"
            >导出报告</el-button
          >
        </div>
        <div style="margin-top: 15px;">最后一次分析：{{ cTime }}</div>
      </div>
      <!-- 封面 -->
      <div
        class="coverPage"
        :style="{
          backgroundColor: '#FFFBDC'
        }"
      >
        <div class="coverPageLogo">
          <img
            style="height: 50px;"
            :src="schoolImg.logo ? schoolImg.logo : ''"
            alt=""
          />
        </div>
        <div class="coverPageFrom" style="z-index: 10;">
          <div class="coverPageFromTit">
            <img
              style="width: 90%;"
              src="../../../assets/icon/exportPdfworks/title.svg"
              alt=""
            />
          </div>
          <div class="termC">
            <div><span>2023-2024</span>学年</div>
            <div style="width: 20px;"></div>
            <div>第<span>2</span>学期</div>
          </div>

          <div class="fromCss">
            <div>
              <span>姓名:</span>
              <div class="txt">{{ worksDialogCon.sName }}</div>
            </div>
            <div>
              <span>班级:</span>
              <div class="txt">
                <el-select
                  v-model="claV"
                  @change="digNum == 0 ? downPdf() : lookPage()"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in claOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- {{ worksDialogCon.class }} -->
              </div>
            </div>
            <div>
              <span>学校:</span>
              <div class="txt">{{ worksDialogCon.schName }}</div>
            </div>
            <div>
              <span>指导老师:</span>
              <div class="txt">
                <div style="transform: translate(-1em, 0px);">
                  {{ worksDialogCon.uname }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="coverPageFrom">
          <img
            style="z-index: 10;width: 90%;transform: translate(0px, -45px);"
            src="../../../assets/icon/exportPdfworks/ropt.svg"
            alt=""
          />
        </div>
      </div>

      <!-- 内容 -->
      <div
        class="coverPageCon"
        v-if="claV"
        :style="{
          backgroundColor: '#FFFBDC'
        }"
      >
        <div
          style="
                text-align: center;
                font-weight: 600;
                font-size: 26px;
                margin: 32px 0;
                color: rgba(58, 59, 152, 1);
              "
        >
          {{ courseTit }}
        </div>
        <div
          style="font-weight: 600; font-size: 20px; color: rgba(0, 0, 0, 0.9);margin: 10px 0;"
        >
          <li>学习总览</li>
        </div>

        <div
          style="display: flex;justify-content: space-between; height: 200px;margin-bottom: 40px"
        >
          <div style="width: 49%;height: 100%;">
            <div
              style="
                  text-align: center;
                  font-weight: 600;
                  font-size: 16px;
                  color: rgba(0, 0, 0, 0.9);
                  margin: 10px 0 15px;
                  width: 100%;
                "
            >
              综合表现
            </div>
            <div
              style="display: flex;width: 100%;height: 100%; justify-content: space-between;flex-wrap: wrap;"
            >
              <div class="zhBlock">
                <div class="zhBlockTit">
                  <span style="margin-right: 5px;font-weight: 600;"
                    >登录时长</span
                  >
                </div>
                <div class="zhBlockCon">{{ loginTime }}</div>
              </div>
              <div class="zhBlock">
                <div class="zhBlockTit">
                  <span style="margin-right: 5px;font-weight: 600;"
                    >学习时长</span
                  >
                </div>
                <div class="zhBlockCon">{{ studyTime }}</div>
              </div>
              <div class="zhBlock">
                <div class="zhBlockTit">
                  <span style="margin-right: 5px;font-weight: 600;"
                    >学习成绩</span
                  >
                </div>
                <div class="zhBlockCon">
                  <div class="zhBlockCon">{{ star }} / 5.0</div>
                </div>
              </div>
              <div class="zhBlock">
                <div class="zhBlockTit">
                  <span style="margin-right: 5px;font-weight: 600;"
                    >包含学科</span
                  >
                </div>
                <div class="zhBlockCon2">
                  <div>
                    <span v-for="(i, index) in subject" :key="index">{{
                      i
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="width: 49%;height: 100%;">
            <div
              style="
                  text-align: center;
                  font-weight: 600;
                  font-size: 16px;
                  color: rgba(0, 0, 0, 0.9);
                  margin: 10px 0 15px;
                  width: 100%;
                "
            >
              工具使用情况
            </div>
            <div ref="ringChart" style="height: 200px; width: 100%"></div>
          </div>
        </div>

        <div
          style="font-weight: 600; font-size: 20px; color: rgba(0, 0, 0, 0.9);margin: 10px 0;"
        >
          <li>学习行为记录</li>
        </div>
        <!-- 作业提交率 -->
        <div class="zxt">
          <div style="height: 260px; width: 100%" ref="toolSubEcharts"></div>

          <div v-loading="canvasLing[0]" class="zxtTxt">
            <div v-if="exitCon[0]" v-html="MarkdownT(AiAnalysisCon2.zy)"></div>
            <el-input
              v-else
              type="textarea"
              resize
              placeholder="请输入内容"
              v-model="AiAnalysisCon2.zy"
            >
            </el-input>
            <div v-if="data10.length" class="zxtBtn">
              <span v-if="exitCon[0]" @click="extCon(0)">编辑</span>
              <span v-else @click="qutCon(0, 'zy')">确定</span>
              <span @click="agAnl(0, 'zy')">重新生成</span>
            </div>
          </div>
        </div>

        <!-- 分组工具使用数量  -->
        <div class="zxt">
          <div style="height: 270px; width: 100%" ref="groupingEcharts"></div>
          <div v-loading="canvasLing[1]" class="zxtTxt">
            <div v-if="exitCon[1]" v-html="MarkdownT(AiAnalysisCon2.zb)"></div>
            <el-input
              v-else
              type="textarea"
              resize
              placeholder="请输入内容"
              v-model="AiAnalysisCon2.zb"
            >
            </el-input>
            <div v-if="data10.length" class="zxtBtn">
              <span v-if="exitCon[1]" @click="extCon(1)">编辑</span>
              <span v-else @click="qutCon(1, 'zb')">确定</span>
              <span @click="agAnl(1, 'zb')">重新生成</span>
            </div>
          </div>
        </div>

        <!-- 师生互动次数  -->
        <div class="zxt">
          <div
            style="height: 270px; width: 100%"
            ref="interactionEcharts"
          ></div>

          <div v-loading="canvasLing[2]" class="zxtTxt">
            <div v-if="exitCon[2]" v-html="MarkdownT(AiAnalysisCon2.shd)"></div>
            <el-input
              v-else
              type="textarea"
              resize
              placeholder="请输入内容"
              v-model="AiAnalysisCon2.shd"
            >
            </el-input>
            <div v-if="data10.length" class="zxtBtn">
              <span v-if="exitCon[2]" @click="extCon(2)">编辑</span>
              <span v-else @click="qutCon(2, 'shd')">确定</span>
              <span @click="agAnl(2, 'shd')">重新生成</span>
            </div>
          </div>
        </div>

        <!-- 互动次数主动  -->
        <div class="zxt">
          <div
            style="height: 270px; width: 100%"
            ref="stuInteractZdEcharts"
          ></div>
          <div v-loading="canvasLing[3]" class="zxtTxt">
            <div
              v-if="exitCon[3]"
              v-html="MarkdownT(AiAnalysisCon2.sshZ)"
            ></div>
            <el-input
              v-else
              type="textarea"
              resize
              placeholder="请输入内容"
              v-model="AiAnalysisCon2.sshZ"
            >
            </el-input>
            <div v-if="data10.length" class="zxtBtn">
              <span v-if="exitCon[3]" @click="extCon(3)">编辑</span>
              <span v-else @click="qutCon(3, 'sshZ')">确定</span>
              <span @click="agAnl(3, 'sshZ')">重新生成</span>
            </div>
          </div>
        </div>
        <!-- 互动次数主动  -->
        <div class="zxt">
          <div
            style="height: 270px; width: 100%"
            ref="bdStuInteractZdEcharts"
          ></div>

          <div v-loading="canvasLing[4]" class="zxtTxt">
            <div
              v-if="exitCon[4]"
              v-html="MarkdownT(AiAnalysisCon2.sshB)"
            ></div>
            <el-input
              v-else
              type="textarea"
              resize
              placeholder="请输入内容"
              v-model="AiAnalysisCon2.sshB"
            >
            </el-input>
            <div v-if="data10.length" class="zxtBtn">
              <span v-if="exitCon[4]" @click="extCon(4)">编辑</span>
              <span v-else @click="qutCon(4, 'sshB')">确定</span>
              <span @click="agAnl(4, 'sshB')">重新生成</span>
            </div>
          </div>
        </div>
        <!-- 课程得分  -->
        <div class="zxt">
          <div style="height: 270px; width: 100%" ref="cScoEcharts"></div>

          <div v-loading="canvasLing[5]" class="zxtTxt">
            <div v-if="exitCon[5]" v-html="MarkdownT(AiAnalysisCon2.ach)"></div>
            <el-input
              v-else
              type="textarea"
              resize
              placeholder="请输入内容"
              v-model="AiAnalysisCon2.ach"
            >
            </el-input>
            <div v-if="data10.length" class="zxtBtn">
              <span v-if="exitCon[5]" @click="extCon(5)">编辑</span>
              <span v-else @click="qutCon(5, 'ach')">确定</span>
              <span @click="agAnl(5, 'ach')">重新生成</span>
            </div>
          </div>
        </div>
        <div v-if="isShowSy" style="width: 100%;">
          <div
            style="font-weight: 600; font-size: 20px; color: rgba(0, 0, 0, 0.9);margin: 10px 0;"
          >
            <li>素养发展情况</li>
          </div>
          <div class="suy">素养发展雷达图</div>
          <div
            style="width: 100%; background-color: #fff;border-radius: 10px;border: 1px solid #ccc;"
          >
            <div
              ref="moreChart"
              style="width: 85%;margin: auto; height: 400px"
            ></div>
          </div>

          <div class="suy">素养发展总览</div>
          <div
            v-if="treeData"
            style=" width: 100%;background-color: #fff;border-radius: 10px;border: 1px solid #ccc;"
          >
            <exjsmind :treeData="treeData"> </exjsmind>
          </div>
        </div>

        <div class="pdfAnalysis">
          <div
            style="font-weight: 600; font-size: 20px; color: rgba(0, 0, 0, 0.9);margin: 10px 0;"
          >
            <li>学习分析报告</li>
          </div>
          <div class="zxt">
            <!-- <div v-loading="canvasLing[6]" v-html="AiAnalysisCon2.allFx"></div> -->

            <div v-loading="canvasLing[6]" class="zxtTxt">
              <div
                v-if="exitCon[6]"
                v-html="MarkdownT(AiAnalysisCon2.allFx)"
              ></div>
              <el-input
                v-else
                type="textarea"
                resize
                placeholder="请输入内容"
                v-model="AiAnalysisCon2.allFx"
              >
              </el-input>
              <div v-if="data10.length" class="zxtBtn">
                <span v-if="exitCon[6]" @click="extCon(6)">编辑</span>
                <span v-else @click="qutCon(6, 'allFx')">确定</span>
                <span @click="agAnl2(6, 'allFx')">重新生成</span>
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex;justify-content: flex-end;">
          <img :src="schoolImg.bjLogo ? schoolImg.bjLogo : ''" alt="" />
        </div>
      </div>

      <!-- 作业内容 -->

      <div
        v-for="i in workList"
        :key="i.id"
        v-if="isStage(i.taskList) && claV && isAllWorkZ"
        class="stageCon"
        :style="{
          backgroundColor: '#FFFBDC'
        }"
      >
        <div class="stageTit">{{ courseTit }}-作业集</div>
        <div
          v-for="k in i.taskList"
          :key="k.task + 'a'"
          class="taskCon"
          v-if="isTask(k.toolEList)"
        >
          <div
            style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 10px;
                "
          >
            <div class="taskTitInd">
              <span>任务{{ k.task + 1 }}</span>
              <span>{{ k.taskTit }}</span>
            </div>
            <div></div>
          </div>
          <div v-if="k.taskDetail" class="taskBri">
            {{ k.taskDetail }}
          </div>
          <div
            class="WorksCon"
            v-for="(l, lind) in k.toolEList"
            :key="lind + 'l'"
          >
            <div
              style="padding: 10px 16px;box-sizing: border-box;"
              v-if="l.content && l.content.length"
            >
              <div v-if="l.tool[0] == 15">
                <div class="toolBlk">
                  <img
                    src="../../../assets/icon/thirdToolList/answer.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：问答工具</div>
                    <div>提问：{{ l.content[0][0].answerTitle }}</div>
                  </div>
                </div>
                <div class="answerTxt">回答:{{ l.content[0][0].answer }}</div>
              </div>
              <div v-if="l.tool[0] == 52">
                <div class="toolBlk">
                  <img
                    src="../../../assets/icon/fourthToolList/text.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：文档工具</div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <div class="answerTxt" v-html="l.content[0].text"></div>
              </div>
              <div v-if="l.tool[0] == 16 || l.tool[0] == 50">
                <div class="toolBlk">
                  <img
                    v-if="l.tool[0] == 16"
                    src="../../../assets/icon/thirdToolList/work.png"
                    alt=""
                  />
                  <img
                    v-if="l.tool[0] == 50"
                    src="../../../assets/icon/thirdToolList/plwork.png"
                    alt=""
                  />

                  <div class="toolTit">
                    <div>
                      工具{{ lind + 1 }}：{{
                        l.tool[0] == 16 ? "作业提交" : "批量上传"
                      }}
                    </div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <div v-for="(i, codex) in l.content" :key="codex + 'co'">
                  <div class="answerTxt" v-html="i"></div>
                </div>
              </div>
              <div v-if="l.tool[0] == 7 || l.tool[0] == 1 || l.tool[0] == 3">
                <div class="toolBlk">
                  <img
                    v-if="l.tool[0] == 1"
                    src="../../../assets/icon/secondToolList/whiteBoard.png"
                    alt=""
                  />
                  <img
                    v-if="l.tool[0] == 3"
                    src="../../../assets/icon/secondToolList/mindMapping.png"
                    alt=""
                  />
                  <img
                    v-if="l.tool[0] == 7"
                    src="../../../assets/icon/secondToolList/mindNetwork.png"
                    alt=""
                  />

                  <div class="toolTit">
                    <div>
                      工具{{ lind + 1 }}：{{
                        l.tool[0] == 1
                          ? "电子白板"
                          : l.tool[0] == 7
                          ? "思维网格"
                          : "思维导图"
                      }}
                    </div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <img
                  @click.stop="previewImg(l.content[0])"
                  style="max-width: 200px"
                  v-if="isDown"
                  :src="l.content[0]"
                  alt=""
                />
                <div>{{ l.content[0] }}</div>
              </div>
              <div v-if="l.tool[0] == 48">
                <div class="toolBlk">
                  <img
                    src="../../../assets/icon/fourthToolList/table.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：表格</div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <el-form>
                  <div class="cont" v-html="l.content[0].text"></div>
                </el-form>
              </div>
              <div v-if="l.tool[0] == 4">
                <div class="toolBlk">
                  <img
                    src="../../../assets/icon/thirdToolList/ask.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：问卷调查</div>
                    <div>标题:{{ l.content[0][0].askJson.askTitle }}</div>
                  </div>
                </div>

                <div
                  style="margin-bottom: 5px"
                  v-for="(i, index) in l.content[0][0].askJson.askJson"
                  :key="index"
                >
                  <div>题目：{{ i.askstitle }}</div>
                  <el-radio-group
                    v-if="!i.type"
                    v-model="l.content[0][0].anwer[index]"
                  >
                    <el-radio
                      v-for="(item2, checkIndex) in i.checkList"
                      :key="checkIndex + 'b'"
                      :label="checkIndex"
                      disabled
                    >
                      {{ item2 }}
                    </el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    v-model="l.content[0][0].anwer[index]"
                    v-else
                  >
                    <div class="radioBox">
                      <el-checkbox
                        v-for="(item2, checkIndex) in i.checkList"
                        :key="checkIndex + 'c'"
                        :label="checkIndex"
                        disabled
                      >
                        {{ item2 }}
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
              <div v-if="l.tool[0] == 45">
                <div class="toolBlk">
                  <img
                    src="../../../assets/icon/thirdToolList/choose.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：选择题</div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <div
                  v-for="(i, index) in l.content[0].testJson"
                  :key="index + 'm'"
                >
                  <div>
                    题目:{{ i.teststitle }}
                    <span
                      v-if="
                        JSON.stringify(l.content[0].radio[index]) ==
                          JSON.stringify(i.answer)
                      "
                      style="color: #868ce4"
                      >回答正确</span
                    >
                    <span v-else style="color: red">回答错误</span>
                  </div>
                  <div
                    v-if="i.type == 1"
                    style="display: flex; flex-direction: column"
                  >
                    <el-radio-group v-model="l.content[0].radio[index]">
                      <div class="radioBox">
                        <el-radio
                          v-for="(item2, checkIndex) in i.checkList"
                          :key="checkIndex + 'b'"
                          :label="checkIndex"
                          disabled
                          :class="[
                            i.answer == checkIndex
                              ? 'redioStyle5'
                              : 'redioStyle2'
                          ]"
                        >
                          <div
                            v-if="item2 && item2.imgType && item2.imgType == 1"
                          >
                            <div
                              class="inImg"
                              @click.stop="previewImg(item2.src)"
                            >
                              <img
                                style="display: block"
                                :src="item2.src"
                                alt=""
                              />
                            </div>
                          </div>
                          <span v-else v-html="item2"></span>
                        </el-radio>
                      </div>
                    </el-radio-group>
                  </div>
                  <div class="radioBox">
                    <el-checkbox-group
                      v-model="l.content[0].radio[index]"
                      v-if="i.type == '2'"
                    >
                      <div class="radioBox">
                        <el-checkbox
                          v-for="(item2, checkIndex) in i.checkList"
                          :key="checkIndex + 'c'"
                          :label="checkIndex"
                          disabled
                          :class="[
                            i.answer.includes(checkIndex)
                              ? 'redioStyle3'
                              : 'redioStyle4'
                          ]"
                        >
                          <div style="display: flex">
                            <div
                              v-if="
                                item2 && item2.imgType && item2.imgType == 1
                              "
                            >
                              <div
                                class="inImg"
                                @click.stop="previewImg(item2.src)"
                              >
                                <img
                                  style="display: block"
                                  :src="item2.src"
                                  alt=""
                                />
                              </div>
                            </div>
                            <span v-else v-html="item2"></span>
                          </div>
                        </el-checkbox>
                      </div>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <!-- 选择匹配 -->
              <div v-if="l.tool[0] == 41">
                <div class="toolBlk">
                  <img
                    class="toolImg"
                    src="../../../assets/icon/thirdToolList/select.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：选择匹配</div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <img
                  @click.stop="previewImg(l.selectJson.url)"
                  style="max-width: 200px"
                  :src="l.selectJson.url"
                  alt=""
                />
                <div>
                  <span style="margin-right: 10px">选项:</span
                  ><span
                    style="margin-right: 10px"
                    v-for="(item, itInd) in l.selectJson.select"
                    :key="itInd"
                    >{{ item }}</span
                  >
                </div>
                <div style="margin: 10px 0;">
                  <span style="margin-right: 10px">回答:</span>

                  <div
                    style="margin-right: 10px"
                    v-for="(item, itInd) in l.content[0]"
                    :key="itInd"
                  >
                    选项{{ itInd + 1 }}：{{ l.selectJson.select[item] }}
                    <span
                      v-if="l.selectJson.answer[itInd] == l.content[0][itInd]"
                      style="color: #868ce4"
                      >回答正确</span
                    >
                    <span v-else style="color: red">回答错误</span>
                  </div>
                </div>
                <div>
                  <span style="margin-right: 10px">答案:</span>

                  <span
                    style="margin-right: 10px"
                    v-for="(item, itInd) in l.selectJson.answer"
                    :key="itInd"
                    >选项{{ itInd + 1 }}：{{ l.selectJson.select[item] }}</span
                  >
                </div>
              </div>
              <!-- <div v-if="l.tool[0] == 41">
                    <div class="toolBlk">
                      <img
                        src="../../../assets/icon/thirdToolList/select.png"
                        alt=""
                      />
                      <div class="toolTit">
                        <div>工具{{ lind + 1 }}：选择匹配</div>
                        <div>
                          根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                        </div>
                      </div>
                    </div>
                    <img
                      @click.stop="previewImg(l.selectJson.url)"
                      style="max-width: 200px"
                      :src="l.selectJson.url"
                      alt=""
                    />
                    <div>
                      <span style="margin-right: 10px">选项:</span
                      ><span
                        style="margin-right: 10px"
                        v-for="(item, itInd) in l.selectJson.select"
                        :key="itInd"
                        >{{ item }}</span
                      >
                    </div>
                    <div>
                      <span style="margin-right: 10px">学生回答:</span>
                      <span
                        style="margin-right: 10px"
                        v-for="(item, itInd) in l.content[0]"
                        :key="itInd"
                        >{{ itInd + 1 }}、{{ l.selectJson.select[item] }}</span
                      >
                    </div>
                  </div> -->

              <!-- 排序 -->
              <div v-if="l.tool[0] == 47">
                <div class="toolBlk">
                  <img
                    src="../../../assets/icon/fourthToolList/conSentences.png"
                    alt=""
                  />
                  <div class="toolTit">
                    <div>工具{{ lind + 1 }}：排序</div>
                    <div>
                      根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                    </div>
                  </div>
                </div>
                <div
                  v-for="(i, index) in l.content[0]"
                  :key="index"
                  style="margin-bottom: 10px"
                >
                  <div
                    style="
                            height: 20px;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                  >
                    题目:
                    <div
                      class="sortTool"
                      v-for="(i, index) in i.addSentence"
                      :key="index"
                    >
                      {{ i }}
                    </div>
                    <span
                      v-if="
                        JSON.stringify(i.chooseSenList) ==
                          JSON.stringify(i.addSentence)
                      "
                      style="color: #868ce4"
                      >回答正确</span
                    >
                    <span v-else style="color: red">回答错误</span>
                  </div>
                  <div
                    style="
                            margin: 10px 0;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                  >
                    学生回答:
                    <div
                      class="sortTool"
                      v-for="(i, index) in i.chooseSenList"
                      :key="index"
                    >
                      {{ i }}
                    </div>
                  </div>
                  <div>
                    答案:
                    <span style="margin: 0 5px">{{
                      i.addSentence.join(",")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- ai作业得分  -->
            <div
              v-if="
                l.content &&
                  l.content.length &&
                  l.eList &&
                  l.eList.length &&
                  (CState == 5 || CState == 6)
              "
              class="taskSco"
            >
              <div class="taskScoTit">
                <div>
                  作业得分：<span style="color: rgba(242, 161, 75, 1)">{{
                    totalScore(l.rate)
                  }}</span>
                  分
                </div>
                <div>作业提交时间：{{ workTime(k.toolEList) }}</div>
              </div>

              <!-- 作业评分 -->
              <div class="taskScoCon">
                <!-- 分数详情与素养 -->
                <div style="flex: 1; display: flex; flex-wrap: wrap">
                  <div style="width: 315px; margin:0 20px 10px 0">
                    <div class="taskScoConTit">分数详情</div>
                    <div
                      v-for="(wItem, ind) in l.eList"
                      :key="ind + 's'"
                      class="score_box"
                      style="width: 100%"
                    >
                      <div
                        style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                min-width: 48%;
                              "
                      >
                        <div class="RootImgBlock">
                          {{ wItem.detail }}
                        </div>

                        <el-rate
                          class="rate_size"
                          disabled-void-color="#ccc"
                          disabled
                          style="width: 130px"
                          v-model="l.rate[wItem.detail]"
                        ></el-rate>
                      </div>
                    </div>
                  </div>

                  <div style="flex: 1">
                    <div class="taskScoConTit">素养</div>
                    <div class="WorkConSY">
                      <div v-for="(wItem, ind) in l.eList" :key="ind + 's'">
                        <!-- <el-tooltip
                          class="item"
                          effect="dark"
                          :content="wItem.detail"
                          placement="top-start"
                        > -->
                          <div class="RootImgBlockSy">
                            {{ wItem.target }}
                          </div>
                        <!-- </el-tooltip> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 评语 -->
                <div
                  style="
                          flex: 1;
                          flex-shrink: 0;
                          display: flex;
                          flex-direction: column;
                          margin-left: 10px;
                        "
                  v-if="l.rate.content"
                >
                  <div class="taskScoConTit">评语</div>
                  <div class="WorkCon">
                    {{ l.rate.content }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 阶段  -->
            <div
              v-if="
                l.eList &&
                  l.eList.length &&
                  CState != 5 &&
                  CState != 6 &&
                  CState != '' &&
                  lind == k.toolEList.length - 1
              "
              class="taskSco"
            >
              <div class="taskScoTit">
                <div>
                  作业得分：<span style="color: rgba(242, 161, 75, 1)">{{
                    totalScore(k.toolEList[0].rate)
                  }}</span>
                  分
                </div>
                <div>作业提交时间：{{ workTime(k.toolEList) }}</div>
              </div>

              <!-- 作业评分 -->
              <div class="taskScoCon">
                <!-- 分数详情与素养 -->
                <div style="flex: 1; display: flex; flex-wrap: wrap">
                  <div style="width: 375px; margin:0 20px 10px 0">
                    <div class="taskScoConTit">分数详情</div>
                    <div
                      v-for="(wItem, ind) in l.eList"
                      :key="ind + 's'"
                      class="score_box"
                      style="width: 100%"
                    >
                      <div
                        style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                min-width: 48%;
                              "
                      >
                        <div class="RootImgBlock">
                          {{ wItem.value }}
                        </div>

                        <el-rate
                          class="rate_size"
                          disabled-void-color="#ccc"
                          disabled
                          style="width: 130px"
                          v-model="k.toolEList[0].rate[wItem.value]"
                        ></el-rate>
                      </div>
                    </div>
                  </div>

                  <div style="flex: 1">
                    <div class="taskScoConTit">素养</div>
                    <div class="WorkConSY">
                      <div v-for="(wItem, ind) in l.eList" :key="ind + 's'">
                        <!-- <el-tooltip
                            class="item"
                            effect="dark"
                            :content="wItem.target[wItem.target.length - 1]"
                            placement="top-start"
                          > -->
                        <div class="RootImgBlockSy">
                          <span v-if="wItem.target && wItem.target.length">
                            {{ wItem.target[wItem.target.length - 1] }}</span
                          >
                          <span v-else> {{ wItem.target }}</span>
                        </div>
                        <!-- </el-tooltip> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 评语 -->
                <div
                  style="
                          flex: 1;
                          flex-shrink: 0;
                          display: flex;
                          flex-direction: column;
                          margin-left: 10px;
                        "
                  v-if="l.rate.content"
                >
                  <div class="taskScoConTit">评语</div>
                  <div class="WorkCon">
                    {{ l.rate.content }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="taskTitInd">
            <div></div>
            <span>任务评价体系</span>
          </div>
          <exjsmind :treeData="k.treeData" :keyL="k.task.toString()"></exjsmind>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="workFrame"
      width="500px"
      style="overflow: hidden;margin-top: 20vh;"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <span>是否同步导出学生作业集?</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="workFrame = false">取消</el-button>
        <el-button size="small" type="primary" @click="downloadPdf(0)"
          >仅报告</el-button
        >
        <el-button size="small" type="primary" @click="downloadPdf(1)"
          >报告（含作业集）</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import exjsmind from "./exjsmind";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import JSZip from "jszip";
import * as echarts from "echarts";
import { v4 as uuidv4 } from "uuid";
import MarkdownIt from "markdown-it";

export default {
  props: [
    "multipleSelection",
    "cid",
    "worksDialog",
    "worksCon",
    "digNum",
    // 是否导出作业集
    "isAllWork"
  ],
  // digNum 0 导出单个报告 1导出所有报告 2查看报告
  components: {
    exjsmind
  },

  data() {
    return {
      star: 0,
      mode: 1,
      workFrame: false,
      // 课程类型
      CState: "",
      isAllWorkZ: "",

      // 课程名称
      courseTit: "",
      classAarray: [],
      cTime: "",
      // 学习时长
      studyTime: "",
      // 登录时长
      loginTime: "",

      canvasLing: [false, false, false, false, false, false, false],
      // 编辑图表分析
      exitCon: [true, true, true, true, true, true, true],

      // 学生作业拼接
      workList: [],
      // 教师id
      userid: this.$route.query.userid,

      isShowSy: true,

      // 选择班级下拉框数据
      claV: "",
      claOptions: [],

      // 环形图数据开始
      toolData: [[], [], [], [], [], [], []],
      toolRatio: [
        { name: "互动类", value: 0 },
        { name: "思维类", value: 0 },
        { name: "协作类", value: 0 },
        { name: "测评类", value: 0 },
        { name: "评价类", value: 0 },
        { name: "编程类", value: 0 },
        { name: "学科类", value: 0 }
      ],
      // 环形图数据结束
      subject: [], //课程分类

      classStageListPer: [], //班级数据
      stageList: [], // 阶段or任务list
      toolPercentage: [], // 每个阶段有的工具
      taskList: [], //每个阶段下有几个任务

      // 作业提交率折线图开始
      stageListPer: [], // 提交作业阶段所占百分比
      // 作业提交率折线图结束

      // 作业得分折线图开始
      scoFoldLineData: [], //课程得分图数据
      claScoFoldLineData: [], //课程得分图数据

      // 作业得分折线图结束

      // 分数工具柱状图开始
      columnData: [
        { name: "个人", data: [] },
        { name: "合作", data: [] }
      ],
      // 分数工具柱状图结束

      // 师生在线互动次数开始
      interact: [], //每个阶段下师生互动工具
      interactWork: [], //每个工具下提交的作业
      // 师生在线互动次数结束

      // 生生互动主动开始
      stuInterAllLike: [],
      claAtuInterAllLike: [],

      // 生生互动主动结束

      // 生生互动被动开始
      bdStuInterAllWork: [],
      bdStuInterAllLike: [],
      // 生生互动被动结束

      // 工具类大分类
      hd: [10, 65],
      sw: [7, 1, 52, 3, 48],
      xz: [49],
      cp: [4, 45, 15, 16, 50, 41, 47],
      pj: [40],
      bc: [18, 21, 23, 24, 32, 57, 63, 71],
      xk: [28, 31, 39, 66, 68, 69, 70],
      // 师生互动工具list
      TeaStuInt: [52, 48, 3, 1, 16, 45, 47, 41],
      // 处理过的分组,师生互动数据
      // TeaStuInt2: [1, 3, 52, 4, 10, 11, 13, 15],

      AiAnalysisCon2Copy: "", //ai数据分析
      AiAnalysisCon2: {
        zy: "", //作业提交
        zb: "", //完成方式占比
        shd: "", //师生互动
        sshZ: "", //生生互动主动
        sshB: "", //生生互动被动
        ach: "", //任务成绩
        allFx: "" //学习分析
      }, //ai数据分析
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      data7: [],
      data8: [],
      data9: [],
      data10: [],
      data11: [],
      data12: [],

      oid: this.$route.query.oid,
      org: this.$route.query.org,
      uid2: "",
      worksDialogCon: JSON.parse(JSON.stringify(this.worksCon)),

      loading: false,
      tableData: [],
      courseName: "",
      imgList: [
        {
          schoolId: "45facc0a-1211-11ec-80ad-005056b86db5",
          logo: require("../../../assets/icon/exportPdfworks/cocoroboLogo.svg"),
          conImg: require("../../../assets/icon/exportPdfworks/cocoroboCon.svg"),
          bjLogo: require("../../../assets/icon/exportPdfworks/logo2.svg"),
          bkColor: "#E5EFFE"
        }
      ],
      schoolImg: {},
      treeData: "",
      languageSetting: "",
      polygonData: [],
      polygonData2: [],
      realData: [],
      mind: null,
      isDown: true,
      workEvaList: []
    };
  },
  mounted() {
    this.isAllWorkZ = JSON.parse(JSON.stringify(this.isAllWork));
    this.getClass();
  },
  computed: {
    isStage() {
      return function(val) {
        let isShow = false;

        val.forEach(e => {
          e.toolEList.forEach(i => {
            if (i.content.length) {
              isShow = true;
            }
          });
        });

        return isShow;
      };
    },
    isTask() {
      return function(val) {
        let isShow = false;

        val.forEach(e => {
          if (e.content.length) {
            isShow = true;
          }
        });

        return isShow;
      };
    },
    totalScore() {
      return function(val) {
        let valT = JSON.parse(JSON.stringify(val));

        if (!valT) return "0.0";

        delete valT.content;
        delete valT.comment;
        // console.log('valT',JSON.parse(JSON.stringify(val)));

        let data = Object.values(valT);
        // console.log('data',JSON.parse(JSON.stringify(data)));

        let new1 = data.reduce(function(pre, next, index) {
          return pre + next * 1;
        });

        if (new1 == 0) return "0.0";

        return (new1 / data.length).toFixed(1);
      };
    },
    workTime() {
      return function(val) {
        if (!val.length) return "";
        let TimeList = [];
        val.forEach(e => {
          if (e.time) {
            const timestamp = new Date(e.time).getTime();
            TimeList.push(timestamp);
          }
        });

        TimeList.sort(function(a, b) {
          return a - b; //从小到大排序
        });
        // console.log('TimeList',TimeList[0]);

        return this.convertToTimestamp(TimeList[0]);
      };
    },
    MarkdownT() {
      return function(c) {
        let md = new MarkdownIt();
        return c ? md.render(c) : "";
      };
    }
  },

  methods: {
    // 时间戳转时间
    convertToTimestamp(val) {
      const date = new Date(val);

      // 使用Date对象的方法获取年、月、日、时、分、秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // 格式化后的日期时间字符串
      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDateTime;
    },
    // 下载单个报告与批量下载
    async downPdf() {
      this.loading = true;
      this.tableData = this.multipleSelection;
      // 单个下载报告
      this.claOptions = [];

      if (this.tableData.length == 1) {
        // 查看学生有几个班级
        let stuCla = [];
        // 获取学生班级
        if (this.tableData[0].classid) {
          stuCla = this.tableData[0].classid.split(",");
        }
        // 处理课程班级与学生班级数据，取相交部分
        this.classAarray.forEach(e => {
          stuCla.forEach(k => {
            if (e.id == k) {
              this.claOptions.push({ value: e.id, label: e.name });
            }
          });
        });

        if (this.claOptions.length == 1) {
          this.claV = this.claOptions[0].value;
        } else if (this.claOptions.length == 0) {
          // 没有班级时
          this.claV = "——";
        } else if (this.claOptions.length > 1 && !this.claV) {
          //有两个及以上班级时
          this.loading = false;

          return this.$message.info("请选择班级");
        }
        // 得到班级数据
        // this.claV = this.claOptions[0].value;

        this.uid2 = this.tableData[0].userid;
        this.worksDialogCon = this.tableData[0];

        await this.getData();

        if (this.data10 && this.data10.length) {
          //当有ai分析时直接下载pdf
          this.loading = false;
          this.isDown = false;
          setTimeout(() => {
            this.getPdf();
          }, 2000);
        } else {
          //当无ai分析时先进行ai分析
          await this.getAiAnalysisCon3();
          this.loading = false;
          this.isDown = false;
          setTimeout(() => {
            this.getPdf();
          }, 2000);
        }
      } else {
        // 批量下载报告
        this.circulatePdf();
      }
    },

    // 一键下载打包压缩包
    getWorks1() {
      this.loading = true;

      let params = {
        cid: this.cid,
        uname: "",
        choseClass: "",
        stage: "",
        task: ""
      };

      this.ajax
        .get(this.$store.state.api + "getCourseWorks6", params) //getCourseWorks4
        .then(res => {
          this.tableData = res.data[0];

          if (!this.tableData.length) {
            this.loading = false;
            return this.$message.info("课程下未有提交作业");
          }
          this.courseName = this.tableData[0].course;
          this.circulatePdf();
        })
        .catch(err => {
          this.isLoading = false;
          console.error(err);
        });
    },

    // 查看pdf报告
    async lookPage() {
      this.loading = true;
      this.claOptions = [];

      // 处理班级，查看学生有几个班级
      let stuCla = [];
      if (this.worksDialogCon.classid) {
        stuCla = this.worksDialogCon.classid.split(",");
      }
      // 处理课程班级与学生班级数据，取相交部分
      this.classAarray.forEach(e => {
        stuCla.forEach(k => {
          if (e.id == k) {
            this.claOptions.push({ value: e.id, label: e.name });
          }
        });
      });

      if (this.claOptions.length == 1) {
        this.claV = this.claOptions[0].value;
      } else if (this.claOptions.length == 0) {
        // 没有班级时
        this.claV = "——";
      } else if (this.claOptions.length > 1 && !this.claV) {
        //有两个及以上班级时
        this.loading = false;
        return this.$message.info("请选择班级");
      }

      await this.getData();
      if (this.data10 && this.data10.length) {
      } else {
        this.$message.info("当前报告暂无分析结果，请先点击【AI分析】");
      }
      this.loading = false;
    },

    getClass() {
      this.loading = true;

      let params = {
        courseId: this.cid
      };
      this.ajax
        .get(this.$store.state.api + "selectCourseDetail2", params) //getCourseWorksReport
        .then(res => {
          // 所有班级
          this.classAarray = res.data[3];
          if (this.digNum == 0) {
            //下载单个与批量下载
            this.downPdf();
          } else if (this.digNum == 1) {
            //一键下载
            this.getWorks1();
          } else {
            //查看
            this.lookPage();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    // 获取处理作业信息
    async exportPdfSet() {
      let params = {
        uid: this.worksDialogCon.userid,
        cid: this.cid
      };
      return new Promise((resolve, reject) => {
        this.ajax
          .get(this.$store.state.api + "selectAllWorksDetail", params)
          .then(res => {
            var worksDetail = res.data[1];
            var askInfo = res.data[3]; //问卷
            var answerInfo = res.data[4]; //问答题
            var pptInfo = res.data[5];
            var chooseInfo = res.data[6]; //选择题
            var pjInfo = res.data[7]; //个人评价作业
            var xztkInfo = res.data[8]; //选择匹配作业
            var lccjInfo = res.data[9]; //排序作业
            var bgInfo = res.data[10]; //表格作业
            var cocopiInfo = res.data[11]; //cocopi或源码编辑作业
            var wordInfo = res.data[12]; //文档作业
            this.workEvaList = res.data[13];

            let framework = [];
            if (res.data[0].length) {
              let elistData = JSON.parse(res.data[0][0].chapters);
              // console.log("elistData", JSON.parse(JSON.stringify(elistData)));

              elistData.forEach((e, i) => {
                framework[i] = {
                  id: i,
                  name: e.dyName ? e.dyName : "",
                  taskList: []
                };
                e.chapterInfo[0].taskJson.forEach((k, kin) => {
                  if (k.eList && k.eList.length) {
                    k.toolChoose.forEach(y => {
                      y.eList = k.eList;
                    });
                  }
                  framework[i].taskList.push({
                    stage: i,
                    task: kin,
                    taskTit: k.task ? k.task : "",
                    taskDetail: k.taskDetail,
                    toolEList: k.toolChoose,
                    treeData: {
                      id: "0",
                      topic: k.task ? k.task : "任务" + i,
                      children: []
                    }
                  });
                });
              });
            }

            res.data[3].forEach(e => {
              e.content = JSON.parse(e.content);
            });
            res.data[4].forEach(e => {
              e.content = JSON.parse(e.content);
            });

            res.data[6].forEach((k, i) => {
              const element1 = JSON.parse(k.content)[0];

              let t = JSON.parse(k.content)[0].testJson;

              // 处理学生选择答案
              let e = [];
              t.testJson.forEach((i, y) => {
                e.push(element1.anwer[y]);
              });
              t.radio = e;

              // 处理选项

              k.content = t;
            });
            res.data[8].forEach((k, i) => {
              k.content = k.content.split(",");
            });
            res.data[9].forEach(e => {
              e.content = JSON.parse(e.content);
            });

            res.data[12].forEach(e => {
              e.content = JSON.parse(e.content);
            });
            res.data[10].forEach(e => {
              e.content = JSON.parse(e.content);
            });

            let AreaAllWork = [
              ...res.data[1],
              ...res.data[3],
              ...res.data[4],
              ...res.data[5],
              ...res.data[6],
              ...res.data[7],
              ...res.data[8],
              ...res.data[9],
              ...res.data[10],
              ...res.data[11],
              ...res.data[12]
            ];

            AreaAllWork.sort(function(a, b) {
              return a.stage - b.stage; //从小到大排序
            });
            // console.log("AreaAllWork", JSON.parse(JSON.stringify(AreaAllWork)));

            framework.forEach(e => {
              e.taskList.forEach((k, kin) => {
                k.toolEList.forEach((l, lIndex) => {
                  l.content = [];
                  l.rate = "";
                  l.time = "";
                  AreaAllWork.forEach((i, index) => {
                    i.tool = i.tool ? i.tool : 0;

                    if (
                      k.stage == i.stage &&
                      k.task == i.task &&
                      lIndex == i.tool
                    ) {
                      l.content.push(i.content);
                      l.time = i.tTime;
                    }
                  });

                  // 分数循环
                  this.workEvaList.forEach(p => {
                    p.tool = p.tool ? p.tool : 0;
                    if (
                      k.stage == p.stage &&
                      k.task == p.task &&
                      lIndex == p.tool
                    ) {
                      let rateCopy = JSON.parse(p.rate);
                      for (const key in rateCopy) {
                        if (key != "content" && key != "") {
                          rateCopy[key] = rateCopy[key] * 1;
                        }
                      }
                      l.rate = rateCopy;
                    }
                  });
                  // 将没有提交作业,但是有评分标准的数据填上数据,防止报错
                  if (
                    !l.rate &&
                    l.eList &&
                    l.eList.length &&
                    (this.CState == 5 || this.CState == 6)
                  ) {
                    l.rate = { content: "" };
                    l.eList.forEach(elp => {
                      l.rate[elp.detail] = 0;
                    });
                  } else if (
                    !l.rate &&
                    l.eList &&
                    l.eList.length &&
                    this.CState != 5 &&
                    this.CState != 6
                  ) {
                    l.rate = { content: "" };
                    l.eList.forEach(elp => {
                      l.rate[elp.value] = 0;
                    });
                  }
                  // 将素养添加进treeData中
                  if (l.eList && l.eList.length) {
                    l.eList.forEach((itemE, itemEInd) => {
                      let arr6 = k.treeData.children.some(
                        item => item.topic == itemE.target
                      );
                      if (!arr6) {
                        k.treeData.children.push({
                          id: kin + "+" + lIndex + "+" + itemEInd,
                          topic: itemE.target,
                          children: []
                        });
                      }
                    });
                  }
                });
              });
            });
            framework.forEach(e => {
              e.taskList.forEach((k, kind) => {
                k.treeData.children.forEach(l => {
                  k.toolEList.forEach((el, elind) => {
                    if (el.eList) {
                      el.eList.forEach((st, stind) => {
                        // console.log(l.topic, st.target, l.topic == st.target);

                        if (l.topic == st.target) {
                          let res3 = l.children.filter(function(item, index) {
                            return item.topic == st.detail;
                          });

                          if (!res3.length) {
                            l.children.push({
                              id: kind + "+" + elind + "+" + stind + "c",
                              topic: st.detail,
                              children: [
                                {
                                  id: kind + "+" + elind + "+" + stind + "b",
                                  topic: `工具${elind * 1 + 1}`
                                }
                              ]
                            });
                          } else {
                            l.children.forEach(lc => {
                              if (lc.topic == st.detail) {
                                lc.children.push({
                                  id: kind + "+" + elind + "+" + stind + "b",
                                  topic: `工具${elind * 1 + 1}`
                                });
                              }
                            });
                          }
                        }
                      });
                    }
                  });
                });
              });
            });

            // console.log("framework", JSON.parse(JSON.stringify(framework)));

            this.workList = framework;

            setTimeout(() => {
              return resolve();
            }, 1500);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    // 获取分析报告数据
    async getData() {
      this.clearData();
      await this.exportPdfSet();
      let params = {
        cid: this.cid,
        uid: this.worksDialogCon.userid,
        cla: this.claV
      };
      return new Promise((resolve, reject) => {
        this.ajax
          .get(this.$store.state.api + "selectStuCourseReportPdfTwo", params) //getCourseWorksReport
          .then(res => {
            let chapters = JSON.parse(res.data[0][0].chapters)[0].chapterInfo[0]
              .taskJson;
            this.CState = res.data[0][0].state;
            this.courseTit = res.data[0][0].title;
            this.cTime = res.data[0][0].cTime;
            this.worksDialogCon.uname = res.data[0][0].uname;

            // ai分析语言
            if (res.data[0][0].setting) {
              try {
                this.languageSetting =
                  JSON.parse(res.data[0][0].setting).languageSetting ||
                  JSON.parse(res.data[0][0].setting).languageSetting == 0
                    ? JSON.parse(res.data[0][0].setting).languageSetting
                    : 0;
              } catch (error) {
                console.error(error);
              }
            }
            // ai分析上传参数
            this.mode = JSON.parse(res.data[0][0].setting).mode
              ? JSON.parse(res.data[0][0].setting).mode
              : 1;

            let sub = res.data[9][0].subject;
            if (res.data[9][0].subject) {
              this.subject = sub.split(",");
            }

            this.imgList.forEach(e => {
              if (e.schoolId == this.oid) {
                this.schoolImg = e;
              }
            });

            // 0 课程信息
            // 1获取登录时长】
            // 2获取登录时长
            //  3获取学生提交作业
            //  4获取单个学生作业分数
            //  5获取教师评价作业
            //  6获取所有学生提交作业
            //  7学生点赞评论次数
            //  8学生被点赞评论次数
            //  8学科
            // 9是否上传过学情分析
            let oneTime = 0;
            res.data[1].forEach(e => {
              oneTime += e.text * 1;
            });
            this.loginTime = this.secondsToDhms(oneTime);

            let twoTime = 0;
            res.data[2].forEach(e => {
              twoTime += e.text * 1;
            });
            this.studyTime = this.secondsToDhms(twoTime);

            this.data3 = res.data[3];
            this.data4 = res.data[4];
            this.data5 = res.data[5];
            this.data6 = res.data[6];
            this.data7 = res.data[7];
            this.data8 = res.data[8];
            this.data9 = res.data[9];
            this.data10 = res.data[10];
            this.data11 = res.data[11];
            this.data12 = res.data[12];
            this.data13 = res.data[13];

            this.getTarget(chapters);

            // 处理这个课程下的工具分类
            let data = JSON.parse(res.data[0][0].chapters);

            this.getDataAiMode(data);

            if (this.data10 && this.data10.length) {
              let Asd = this.data10[0].jsonTxt;
              this.AiAnalysisCon2 = JSON.parse(Asd);
              this.AiAnalysisCon2Copy = JSON.parse(
                JSON.stringify(this.AiAnalysisCon2)
              );
            }
            this.loading = false;

            setTimeout(() => {
              return resolve(1);
            }, 2000);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    // 处理素养发展情况
    getTarget(data) {
      // 素养与分数重组后的数据
      let tar = [];
      // console.log('data',JSON.parse(JSON.stringify(data)));

      // 细分出每个任务工具的细则
      data.forEach((e, i) => {
        tar[i] = [];
        e.toolChoose.forEach((k, ki) => {
          tar[i].push(k);
        });
      });

      // console.log("tar", JSON.parse(JSON.stringify(tar)));
      let zjm = [];
      tar.forEach((e, i) => {
        e.forEach(k => {
          if (k.eList) {
            zjm.push(k);
          }
        });
      });
      if (zjm.length == 0) return (this.isShowSy = false);

      // 将提交的作业塞进对应的数组素养内
      let data4Copy = JSON.parse(JSON.stringify(this.data4));
      data4Copy.forEach(e => {
        e.tarD = JSON.parse(e.rate);
      });
      // console.log('tar',JSON.parse(JSON.stringify(tar)));
      // console.log('data4Copy',JSON.parse(JSON.stringify(data4Copy)));

      tar.forEach((k, ki) => {
        data4Copy.forEach((e, ei) => {
          if (ki == e.task) {
            if (k[e.tool ? e.tool : 0]) {
              k[e.tool ? e.tool : 0].rate = e.tarD;
            }
          }
        });
      });
      // 将任务添加进tool中，因为最后要算任务平均分
      tar.forEach((k, ki) => {
        k.forEach(e => {
          e.task = ki;
        });
      });

      // 将全部数据整合在一起，没有评分细则的数据去除掉
      let tarCopy = [];
      tar.forEach((e, i) => {
        e.forEach(k => {
          if (k.eList) {
            tarCopy.push(k);
          }
        });
      });

      // 将task加入细则中
      tarCopy.forEach(e => {
        e.eList.forEach(k => {
          k.task = e.task;
        });
      });

      // 将分数加进对应细则中
      tarCopy.forEach(e => {
        e.eList.forEach(k => {
          k.cog = 0;
          for (const key in e.rate) {
            if (k.detail === key) {
              k.cog = e.rate[key];
            }
          }
        });
      });
      console.log("tarCopy", JSON.parse(JSON.stringify(tarCopy)));

      // 将细则的素养全部放到一个数组中
      let tarList = [];
      tarCopy.forEach(e => {
        e.eList.forEach(k => {
          tarList.push(k);
        });
      });

      // 合并相同素养
      let tarListCopy = this.tarArrFn(tarList);

      // 素养多边形数据
      let polygonData = this.tarArrFn(tarList);

      // console.log("polygonData", JSON.parse(JSON.stringify(polygonData)));
      // console.log("tarList", JSON.parse(JSON.stringify(tarList)));

      polygonData.forEach(e => {
        e.sco = 0;
        tarList.forEach(k => {
          if (e.topic == k.target) {
            e.children.push(k.cog);
          }
        });
        e.sco = e.children.reduce(function(pre, next, index) {
          return pre * 1 + next * 1;
        });
        if (e.sco) {
          e.sco = (e.sco / e.children.length).toFixed(2);
        }
      });
      this.polygonData = polygonData;

      polygonData.forEach(e => {
        this.polygonData2.push(e.sco);
      });

      tarListCopy.forEach((e, ei) => {
        tarList.forEach((i, ik) => {
          // 判断评价标准是否重叠，如果重叠，就将任务合并
          if (e.topic == i.target) {
            let res3 = e.children.filter(function(item, index) {
              return item.topic === i.detail;
            });

            if (res3.length) {
              // 如果有重复，把素养下的children循环，帮分数放到对应的标准下
              // console.log("e.children", e.children);
              e.children.forEach(p => {
                if (p.topic == i.detail) {
                  let kCon = p.children.filter(function(item, index) {
                    return item.topic == `任务${i.task + 1}`;
                  });

                  if (kCon.length) {
                    p.children.forEach(s => {
                      if (s.topic == `任务${i.task + 1}`) {
                        s.children[0].topic += `${i.cog},`;
                      }
                    });
                  } else {
                    p.children.push({
                      id: `ne${ik}${ei}`,
                      topic: `任务${i.task + 1}`,
                      children: [
                        {
                          id: `n${ik}${ei}`,
                          topic: `${i.cog},`
                        }
                      ]
                    });
                  }
                }
              });
            } else {
              // 标准
              let obj = { id: `noe${ik}${ei}`, topic: i.detail, children: [] };

              // 分数
              let kCon = obj.children.filter(function(item, index) {
                return item.topic == `任务${i.task + 1}`;
              });
              // console.log('kCon',kCon);

              if (kCon.length) {
                obj.children.forEach(s => {
                  if (s.topic == `任务${i.task + 1}`) {
                    s.children[0].topic += `${i.cog},`;
                  }
                });
              } else {
                obj.children = [
                  {
                    id: `ne${ik}${ei}`,
                    topic: `任务${i.task + 1}`,
                    children: [
                      { id: `n${ik}${ei}`, topic: `${i.cog},` }
                      // { id: `n${ik}${ei}`, topic: i.cog ? `${i.cog}分` : "0分" }
                    ]
                  }
                ];
              }
              e.children.push(obj);
            }
          }
        });
      });
      // console.log("tarListCopy", JSON.parse(JSON.stringify(tarListCopy)));

      tarListCopy.forEach(e => {
        //素养
        e.children.forEach(k => {
          //标准
          k.children.forEach(l => {
            //任务
            let arr = l.children[0].topic.split(",");
            // console.log('arr',arr);

            let num = arr.reduce(function(pre, next, index) {
              return pre * 1 + next * 1;
            });
            if (num) {
              l.children[0].topic = (num / (arr.length - 1)).toFixed(1);
            } else {
              l.children[0].topic = "0";
            }
          });
        });
      });
      // console.log("this.treeData", JSON.parse(JSON.stringify(this.treeData)));

      this.treeData = {
        id: "0",
        topic: this.courseTit,
        children: tarListCopy
      };

      // setTimeout(() => {
      this.moreRenderChart();
      // }, 100);
    },

    downloadPdf(val) {
      if (val) {
        this.isAllWorkZ = true;
      } else {
        this.isAllWorkZ = false;
      }
      this.isDown = false;
      this.workFrame = false;

      // this.renderChart2(); //环形
      // this.initChart();    // 作业提交率折线图
      // this.initChart2(); // 阶段成绩 任务成绩
      // this.initChart3(); // 分组工具占比
      // this.initChart4(); // 师生互动折线图
      // this.initChart5(); // 学生互动主动折线图
      // this.initChart6(); // 学生互动被动折线图
      // this.moreRenderChart();
      setTimeout(() => {
        this.renderChart2(); //环形
        this.initChart(); // 作业提交率折线图
        this.initChart2(); // 阶段成绩 任务成绩
        this.initChart3(); // 分组工具占比
        this.initChart4(); // 师生互动折线图
        this.initChart5(); // 学生互动主动折线图
        this.initChart6(); // 学生互动被动折线图
        this.moreRenderChart();
      }, 500);

      setTimeout(() => {
        this.getPdf();
      }, 2000);
    },

    isGetPdf() {
      this.workFrame = true;
      // this.$confirm("确定导出本次学生报告吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     this.isDown = false;
      //     setTimeout(() => {
      //       this.getPdf();
      //     }, 500);
      //   })
      //   .catch(() => {});
    },
    // 下载pdf文件
    async getPdf() {
      // console.log("content", content.offsetHeight);

      // html2canvas(content)
      //   .then(canvas => {
      //     const imgData = canvas.toDataURL("image/png");
      //     const pdf = new jspdf("p", "pt", [
      //       content.offsetWidth,
      //       content.offsetHeight
      //     ]);

      //     pdf.addImage(
      //       imgData,
      //       "PNG",
      //       0,
      //       0,
      //       content.offsetWidth,
      //       content.offsetHeight
      //     );
      //     pdf.save(
      //       this.worksDialogCon.course +
      //         "-学生成长报告-" +
      //         this.worksDialogCon.sName +
      //         ".pdf"
      //     );

      //     this.isDown = true;
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });

      const content = this.$refs.reportPdf;
      const dpi = 300;
      html2canvas(content, {
        dpi: dpi, // 设置截图的分辨率
        scale: dpi / 96 // 设置截图缩放比例，以适应pdf的dpi
      }).then(canvas => {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;

        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = (592.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/jpeg", 1.0);

        var pdf = new jsPDF("", "pt", [imgWidth, imgHeight]);

        pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);

        pdf.save(
          this.worksDialogCon.course +
            "-学生成长报告-" +
            this.worksDialogCon.sName +
            ".pdf"
        );
        this.isDown = true;
      });
    },

    // 学习行为记录获取ai分析
    async AIPdfComment(dataVal) {
      // console.log(dataVal);
      let messages = "";
      if (dataVal.nam == "zy") {
        messages = `Language: ${this.getLang()}

       #上下文#
        学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并以数据的形式记录。
        当前数据反映了学生的【作业提交率】。每个任务有若干工具支持学生完成作业，平台会自动计算每个任务的工具提交率，
        作为作业提交情况的反馈，表现形式为双折线图。图表中会有两条折线，分别表示个人作业提交率和班级作业提交率。
        这个数据能够反映学生的学习态度和学习习惯等。

        #目标#
        1.你是一个学生学习行为分析专家，你可以通过解读数据，描述图表（班级作业提交率和个人作业提交率），分析趋势，
        给教师和家长指导建议。生成的内容中的数据格式为百分数。你要解读以下数据：
        <个人数据：${dataVal.per}>
        <班级数据：${dataVal.cla}>
        2.不用列出每个任务的提交率，不要输出无关的互动性语言，生成后不要询问。
        3.参考输出格式，输出markdown格式内容。

        #风格#
        专业的

        #语气#
        陈述

        #受众#
        教师、家长

        #输出格式#
        **班级作业提交率**
        内容（解读数据可能反应的学习情况）
        **个人作业提交率**
        内容（解读数据可能反应的学习情况）
        **趋势分析**
        内容
        **指导建议**
        内容
      `;
      } else if (dataVal.nam == "zb") {
        messages = `Language:  ${this.getLang()}

       #上下文#
        学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并以数据的形式记录。
        当前数据反映了学生的【完成方式占比】。每个任务有若干工具支持学生完成作业，有支持个人独立完成作业的工具，
        也有支持小组合作完成作业的工具。学生提交作业后，系统会自动根据学生完成的方式计算比例，表现形式为堆叠柱状图。
        不能直接通过这个比例判断学生缺少或具备合作能力。可以在一定程度上反映教学环节的设计，
        以及学生这这个任务中锻炼了独立/合作解决问题的能力。

        #目标#
        1.你是一个学生学习行为分析专家，你可以通过解读数据，描述图表（个人完成率和合作完成率），分析学生能力培养情况，给教师和家长指导建议。生成的内容中的数据格式为百分数。你要解读以下数据：
        <独立完成：${dataVal.per}>
        <合作完成：${dataVal.cla}>
        2.参考输出格式，输出markdown格式内容，不要无关的互动性语言。


        #风格#
        专业的

        #语气#
        陈述

        #受众#
        教师、家长

       #输出格式#
        **个人完成率**
        内容
        **合作完成率**
        内容
        **能力培养情况**
        内容
        **指导建议**
        内容
        `;
      } else if (dataVal.nam == "shd") {
        messages = `Language:  ${this.getLang()}

       #上下文#
        学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并以数据的形式记录。
        当前数据反映了学生的【师生互动】。每个任务有若干工具支持学生完成作业，学生提交作业后，教师会对学生的作业进行评价，这样的互动行为会被平台记录为师生互动，表现形式为双折线图。图表中有两条折线，分别表示个人互动次数和班级平均互动次数。这个数据不能反映学生在寻求教师反馈和指导方面的主动性。可以在某种程度上提醒老师关注学生的作业提交情况以及作业质量。

        #目标#
        1.你是一个学生学习行为分析专家，你可以通过解读数据，描述图表（班级平均互动次数和个人互动次数），分析趋势，给教师和家长指导建议。你要解读以下数据：

        <个人数据：${dataVal.per}>
        <班级数据：${dataVal.cla}>
        2.不用列出每个任务的互动次数，不要输出无关的互动性语言，生成后不要询问。
        2.参考输出格式，输出markdown格式内容。

        #风格#
        专业的

        #语气#
        陈述

        #受众#
        教师、家长和教育管理者

       #输出格式#
        **班级平均互动次数**
        内容（解读数据可能反应的学习情况）
        **个人互动次数**
        内容（解读数据可能反应的学习情况）
        **趋势分析**
        内容
        **指导建议**
        内容
        `;
      } else if (dataVal.nam == "sshZ") {
        messages = `Language:  ${this.getLang()}

        #上下文#
        学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并以数据的形式记录。
        当前数据反映了学生的【生生互动（主动）】。每个任务有若干工具支持学生完成作业，当教师开放查看权限，
        学生可以查看同学的作业并点赞和评论。每一次点赞或评论会被平台记录为一次主动发起的生生互动，表现形式为双折线图。
        图表中有两条折线，分别表示个人发起互动次数和班级平均发起互动次数。这个数据可能会反映学生的学习积极性。


        #目标#
        1.你是一个学生学习行为分析专家，你可以通过解读数据，描述图表（班级平均互动次数和个人互动次数），分析趋势，给教师和家长指导建议。你要解读以下数据：
        <个人数据：${dataVal.per}>
        <班级数据：${dataVal.cla}>
        2.不用列出每个任务的互动次数，不要输出无关的互动性语言，生成后不要询问。
        3.参考输出格式，输出markdown格式内容。

        #风格#
        专业的

        #语气#
        陈述

        #受众#
        教师、家长

        #输出格式#
        **班级平均互动次数**
        内容（解读数据可能反应的学习情况）
        **个人互动次数**
        内容（解读数据可能反应的学习情况）
        **趋势分析**
        内容
        **指导建议**
        内容
        `;
      } else if (dataVal.nam == "sshB") {
        messages = `Language:  ${this.getLang()}

        #上下文#
        学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并以数据的形式记录。
        当前数据反映了学生的【生生互动（被动）】：每个任务有若干工具支持学生完成作业，当教师开放查看权限，
        学生可以查看同学的作业并点赞和评论。每一次获得点赞或评论会被平台记录为一次被动接受的生生互动，
        表现形式为双折线图。图表中有两条折线，分别表示个人接受互动次数和班级平均接受互动次数。
        这个数据可能会反映作业完成情况以及学生的受欢迎程度。


        #目标#
        1.你是一个学生学习行为分析专家，你可以通过解读数据，描述图表（班级平均互动次数和个人互动次数），分析趋势，给教师和家长指导建议。你要解读以下数据：
        <个人数据：${dataVal.per}>
        <班级数据：${dataVal.cla}>
        2.不用列出每个任务的互动次数，不要输出无关的互动性语言，生成后不要询问。
        3.参考输出格式，输出markdown格式内容。

        #风格#
        专业的

        #语气#
        陈述

        #受众#
        教师、家长

        #输出格式#
        **班级平均互动次数**
        内容（解读数据可能反应的学习情况）
        **个人互动次数**
        内容（解读数据可能反应的学习情况）
        **趋势分析**
        内容
        **指导建议**
        内容
        `;
      } else if (dataVal.nam == "ach") {
        messages = `Language:  ${this.getLang()}

        #上下文#
        学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并以数据的形式记录。
        当前数据反映了学生的【任务成绩】：每个任务有若干工具支持学生完成作业，任务中每个作业都会被评分，
        平台会自动计算作业的平均分作为当前任务的得分。图表中有两条折线，分别表示个人任务成绩和班级任务成绩。
        这个数据能够在一定程度上反映学生的学习态度、学习能力和学习效果。


        #目标#
        1.你是一个学生学习行为分析专家，你可以通过解读数据，描述图表（班级平均成绩和个人成绩），分析趋势，给教师和家长指导建议。你要解读以下数据：
        <个人数据：${dataVal.per}>
        <班级数据：${dataVal.cla}>
        2.不要输出无关的互动性语言，生成后不要询问。
        3.参考输出格式，输出markdown格式内容。


        #风格#
        专业的

        #语气#
        陈述

        #受众#
        教师、家长

        #输出格式#
        **班级平均成绩**
        内容（解读数据可能反应的学习情况）
        **个人成绩**
        内容（解读数据可能反应的学习情况）
        **趋势分析**
        内容
        **指导建议**
        内容
        `;
      }

      let params = {
        model: "gpt-4o-2024-11-20",
        temperature: this.mode == 3 ? 0.5 : 0.1,
        max_tokens: 4096,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
        messages: [
          {
            content: messages.replaceAll("\n", " ").replaceAll("*", ""),
            role: "user"
          }
        ],
        stream: false,
        uid: this.userid,
        mind_map_question: ""
      };

      return new Promise((resolve, reject) => {
        this.ajax
          .post("https://gpt4.cocorobo.cn/chat", params)
          .then(response => {
            let data = response.data.FunctionResponse;
            console.log("data", data);
            let md = new MarkdownIt();

            if (
              data.choices &&
              data.choices.length &&
              data.choices[0].message
            ) {
              let content = data.choices[0].message.content;
              this.AiAnalysisCon2[dataVal.nam] = content
                .replaceAll("<br>", "")
                .replaceAll("```", "")
                .replaceAll("markdown", "");
            }

            return resolve(1);
          })
          .catch(error => {
            console.log(error);
            return resolve();
          });
      });
    },
    // 处理学习分析报告
    async updateFx() {
      // 素养发展数据
      let poy = "";
      this.polygonData.forEach(e => {
        poy += `${e.topic}:${e.sco}`;
      });

      let num = 0;
      let toolCopy = JSON.parse(JSON.stringify(this.toolRatio));
      toolCopy.forEach(e => {
        num += e.value * 1;
      });

      toolCopy.forEach(e => {
        e.value = (e.value / num).toFixed(2);
      });

      console.log("this.toolCopy", toolCopy);
      let txt = "";
      toolCopy.forEach(e => {
        txt += `${e.name}:${e.value * 100}%,`;
      });

      let messages = `Language:${this.getLang()}

      #上下文#
      学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并对数据进行整理然后绘制图表，平台会对图表进行描述和分析。你是一个学生学习行为分析专家，可以借助数据和图表分析结果评估学生，输出一份学生学习行为分析报告。
      素养发展雷达图中的每个维度表示课程目标，即学生通过学习培养的素养。素养发展总览以树状图的形式从左到右分别展示了“课程标题”、“素养”、“任务评价标准”、“任务序号”和使用工具完成的作业在当前评价标准维度的“得分”。
      你可以通过学生的登录时长、学习时长、作业提交率、互动等数据评估学生的学习积极性。你可以通过学生的完成任务方式、任务成绩、工具使用情况等数据评估学生的学习效果。你可以通过素养发展雷达图和素养发展等数据评估学生素养成长情况。你可以综合给你数据对学生的学习情况进行科学的、专业的分析。

      #目标#
      你要结合参考资料中的数据和图表分析结果，对学生的学习行为进行评估，并生成一份学习分析报告。报告要按顺序输出以下几个方面，格式参考输出范例。
      1.学习概况。包含了学生【登录时长】【学习时长】【学习成绩】以及在班级中所处的排名。不需要评估，陈述数据即可。
      2.学习积极性。陈述评估结果，描述参考数据以及得出结论的过程。
      3.学习效果。陈述评估结果，描述参考数据以及得出结论的过程。
      4.学生素养成长情况。分析素养发展数据，陈述评估结果。
      5.学生学习画像。总结以上四个步骤的结论，输出总结性词条，描绘学习者画像。
      6.个性化学习建议。结合以上五个步骤的结论，提出6条与该学生高度匹配的个性化学习建议。
      注意：不要输出无关的互动性语言，生成后不要询问。

      #参考资料#
      <登录时长：${this.loginTime}>
      <学习时长：${this.studyTime}>
      <课程得分：${this.star}/5.0>
      <学科：${this.subject.join(",")}>
      <工具使用情况：${txt}>

      <作业提交率分析：${this.AiAnalysisCon2.zy}>
      <完成方式占比分析：${this.AiAnalysisCon2.zb}>
      <师生互动分析：${this.AiAnalysisCon2.shd}>
      <生生互动（主动）分析：${this.AiAnalysisCon2.sshZ}>
      <生生互动（被动）分析：${this.AiAnalysisCon2.sshB}>
      <任务成绩分析：${this.AiAnalysisCon2.ach}>

      素养发展:${poy}

      #风格#
      专业的

      #语气#
      陈述

      #受众#
      教师、家长和教育管理者

      #输出范例#
# 学习概况
    * 登陆时长：【1天2小时】
    * 学习时长：【1天2小时】
    * 课程得分：【4.4/5.0】
---
# 学习积极性
    学生在课程中的登录和学习时长均位于班级前25%，表明学生具有较高的 学习参与度和时间投入。此外，频繁使用平台工具(22次)也显示了学生在 学习过程中积极利用可用资源，保持了良好的学习状态。
    学生在学习过程中表现出积极的学习态度。学生大多数任务能准时提交，虽然有1次未交和2次迟交，但整体表现较好。此外，师生和生生互动次数均高于或等于班级平均值，表明学生在学习过程中积极主动，与教师和同学保持良好的互动，显示出较强的学习动力。
---
# 学习效果
    学生课程得分为4.4/5.0，高于班级平均水平，说明学生在知识掌握和技能应用方面表现出色。在每个阶段任务得分上，大多数高于或等于班级平均值，证明学生每个阶段的任务都能较好的完成，最终较高水平地达成了课程学习目标(能力、知道、理解)。
    协作完成的任务占总任务的36.6%，独立完成的任务占63.3%，显示出学生既具备独立学习的能力，又能有效地与他人协作。
    学生参与了科学、数学、美术学科的学习与实践，表明在多学科领域都有所涉猎，具备全面发展的潜力。
---
# 学生素养发展情况
    学生在科学观念（科学）维度获得4.4分，说明学生在知识掌握和技能应用方面表现出色，该素养得到了较好的发展。在艺术表现（艺术）维度获得1.5分，说明学生在创造艺术形象、表达思想感情、展现艺术美感的实践能力上仍有发展空间。
---
# 学生学习画像
    * 学习积极主动
    * 学业表现优秀
    * 独立与协作兼备
---
#个性化学习建议：
    1.**加强时间管理:** 尽量避免任务迟交和未交情况，进一步提升学习效率。
    2.**增加协作机会:** 尝试更多的团队协作任务，提升协作能力和团队意识。
    3.**保持积极互动: ** 继续保持与教师和同学的良好互动，充分利用在线学习平台的优势。
    4.**拓展学习领域: ** 在已有学科基础上，尝试探索更多学科领域，提升综合素质。
    5.**定期自我评估：** 定期对自己的学习成果进行自我评估，以确保学习目标与个人发展目标一致。
    6.**学习策略优化：** 尝试不同的学习方法，如主动学习、可视化学习等，找到最适合自己的学习策略。    `;

      let params = {
        model: "gpt-4o-2024-11-20",
        temperature: this.mode == 3 ? 0.5 : 0.1,
        max_tokens: 4096,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
        messages: [
          {
            content: messages.replaceAll("\n", " ").replaceAll("*", ""),
            role: "user"
          }
        ],
        stream: false,
        uid: this.userid,
        mind_map_question: ""
      };
      return new Promise((resolve, reject) => {
        this.ajax
          .post("https://gpt4.cocorobo.cn/chat", params)
          .then(response => {
            let data = response.data.FunctionResponse;
            console.log("data", data);

            if (
              data.choices &&
              data.choices.length &&
              data.choices[0].messagea
            ) {
              let content = data.choices[0].message.content;
              this.AiAnlysisCon2.allFx = content.replaceAll("<br>", "");
            }

            this.loading = false;
            this.canvasLing.splice(6, 1, false);

            this.uploadData();
            return resolve(1);
          })
          .catch(error => {
            this.canvasLing.splice(6, 1, false);

            console.log(error);
          });
      });
    },
    async getAiAnalysisCon3() {
      await this.getAiAnalysisCon2();
      // console.log("666");
      await this.updateFx();

      // console.log("111");
    },
    // 处理学习行为记录ai分析数据
    async getAiAnalysisCon2() {
      return new Promise((resolve, reject) => {
        this.$message.info("开始分析中...");
        let realData = [
          { per: "", cla: "", nam: "zy" },
          { per: "", cla: "", nam: "zb" },
          { per: "", cla: "", nam: "shd" },
          { per: "", cla: "", nam: "sshZ" },
          { per: "", cla: "", nam: "sshB" },
          { per: "", cla: "", nam: "ach" }
        ];
        for (let index = 0; index < this.canvasLing.length; index++) {
          this.canvasLing.splice(index, 1, true);
        }
        // 作业提交率
        this.stageListPer.forEach((e, index) => {
          realData[0].per += `任务${index + 1}：${e}，`;
        });
        this.classStageListPer.forEach((e, index) => {
          realData[0].cla += `任务${index + 1}：${e}，`;
        });

        // 完成任务方式占比
        this.columnData[0].data.forEach((e, index) => {
          realData[1].per += `任务${index + 1}：${e}，`;
        });
        this.columnData[1].data.forEach((e, index) => {
          realData[1].cla += `任务${index + 1}：${e}，`;
        });

        // 师生互动
        this.interactWork.forEach((e, index) => {
          realData[2].per += `任务${index + 1}：${e}，`;
        });
        this.claInteractWork.forEach((e, index) => {
          realData[2].cla += `任务${index + 1}：${e}，`;
        });

        // 生生互动（主动）
        this.stuInterAllLike.forEach((e, index) => {
          realData[3].per += `任务${index + 1}：${e.length}，`;
        });
        this.claAtuInterAllLike.forEach((e, index) => {
          realData[3].cla += `任务${index + 1}：${e}，`;
        });

        // 生生互动（被动）
        this.bdStuInterAllLike.forEach((e, index) => {
          realData[4].per += `任务${index + 1}：${e.length}，`;
        });
        this.claAtuInterAllLike.forEach((e, index) => {
          realData[4].cla += `任务${index + 1}：${e}，`;
        });

        // 任务成绩
        this.scoFoldLineData.forEach((e, index) => {
          realData[5].per += `任务${index + 1}：${e}，`;
        });
        this.claScoFoldLineData.forEach((e, index) => {
          realData[5].cla += `任务${index + 1}：${e}，`;
        });

        // console.log("realData", realData);
        this.realData = realData;

        let forAllList = [];

        for (let i = 0; i < realData.length; i++) {
          let mkAwit = this.AIPdfComment(realData[i]);
          forAllList.push(mkAwit);
        }
        Promise.all(forAllList)
          .then(async values => {
            // console.log(" this.AiAnalysisCon2", this.AiAnalysisCon2);
            for (let index = 0; index < values.length; index++) {
              this.canvasLing.splice(index, 1, false);
            }
            return resolve(1);
          })
          .catch(reason => {
            console.error("reason", reason);
          });
      });
    },
    // 上传ai分析
    uploadData() {
      let params = [
        {
          cid: this.cid,
          uid: this.worksDialogCon.userid,
          con: JSON.stringify(this.AiAnalysisCon2),
          clav: this.claV
        }
      ];
      this.ajax
        .post(this.$store.state.api + "upDateAnalysisTwo", params) //getCourseWorksReport
        .then(res => {
          this.AiAnalysisCon2Copy = JSON.parse(
            JSON.stringify(this.AiAnalysisCon2)
          );
          this.$message.success("AI分析已完成");

          let params = {
            cid: this.cid,
            uid: this.worksDialogCon.userid,
            cla: this.claV
          };
          this.ajax
            .get(this.$store.state.api + "selectStuCourseReportPdfTwo", params) //getCourseWorksReport
            .then(res => {
              this.cTime = res.data[0][0].cTime;
            })
            .catch(err => {
              console.error(err);
            });
        })
        .catch(err => {
          console.error(err);
        });
    },
    // 判断ai分析语言
    getLang() {
      let lang = "";
      if (this.languageSetting == 0) {
        lang = "Chinese.";
      } else if (this.languageSetting == 1) {
        lang = "Traditional Chinese.";
      } else if (this.languageSetting == 2) {
        lang = "English.";
      }
      return lang;
    },

    // 一键打包所有作业
    async circulatePdf() {
      let _this = this;
      var zip = new JSZip();
      let pdfList = [];
      this.isDown = false;

      for (let i = 0; i < this.tableData.length; i++) {
        this.loading = true;

        let stuCla = "";
        let ClaNam = "";
        this.claOptions = [];
        this.claV = "——";

        if (this.tableData[i].classid) {
          stuCla = this.tableData[i].classid.split(",");
          ClaNam = this.tableData[i].class.split(",");
          this.claV = stuCla[0];
          this.claOptions.push({ value: stuCla[0], label: ClaNam[0] });
        }
        this.uid2 = this.tableData[i].userid;
        this.worksDialogCon = this.tableData[i];

        await this.getData();

        if (this.data10 && this.data10.length) {
        } else {
          await this.getAiAnalysisCon3();
        }
        // console.log('555');

        let a = await this.getPdf2();
        // console.log(a);

        // console.log('666');

        pdfList.push(a);
      }

      pdfList.forEach((e, index) => {
        zip.file(e.pdfName, e.pdfCon);
      });

      // 生成压缩包并提供下载链接
      zip.generateAsync({ type: "blob" }).then(function(content) {
        // 使用FileSaver保存压缩包
        saveAs(content, _this.courseTit + "-学生报告汇总.zip");
      });
      this.isDown = true;

      this.$emit("update:worksDialog", false);
      // this.worksDialog = false;
    },
    // 压缩pdf
    async getPdf2() {
      const content = this.$refs.reportPdf;

      return new Promise((resolve, reject) => {
        const dpi = 300;
        html2canvas(content, {
          dpi: dpi, // 设置截图的分辨率
          scale: dpi / 96 // 设置截图缩放比例，以适应pdf的dpi
        }).then(canvas => {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height;

          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28;
          var imgHeight = (592.28 / contentWidth) * contentHeight;

          var imgData = canvas.toDataURL("image/jpeg", 1.0);

          const pdf = new jsPDF("p", "pt", [imgWidth, imgHeight]);

          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
          var pdfData = {
            pdfName:
              this.worksDialogCon.course +
              "-学生报告-" +
              this.worksDialogCon.sName +
              ".pdf",
            pdfCon: pdf.output("blob")
          };

          return resolve(pdfData);
        });
      }).catch(err => {
        console.log(err);
      });
    },

    // ai模式处理数据
    getDataAiMode(data) {
      // console.log('getDataAiMode',data);

      data.forEach((e, eInd) => {
        let toolList = e.chapterInfo[0].taskJson;
        toolList.forEach((i, iInd) => {
          this.stageList.push("任务" + (iInd * 1 + 1));
          this.toolPercentage[iInd] = []; // 每个任务有的工具
          this.stageListPer.push(0); // 作业提交率基础数据折线图
          this.classStageListPer.push(0);

          // 课程阶段下互动数据工具
          this.interact[iInd] = [];

          this.interactWork[iInd] = []; //每个工具下提交的作业

          this.stuInterAllLike[iInd] = []; // 生生互动阶段点赞评论分类

          this.bdStuInterAllWork[iInd] = []; // 生生互动阶段被动作业分类
          this.bdStuInterAllLike[iInd] = []; // 生生互动阶段被动点赞评论分类

          i.toolChoose.forEach(k => {
            if (k.tool[0]) {
              this.toolPercentage[iInd].push(k.tool[0]);
              if (this.TeaStuInt.indexOf(k.tool[0]) != -1) {
                this.interact[iInd].push(k.tool[0]);
              }
              if (this.hd.indexOf(k.tool[0]) != -1) {
                this.toolData[0].push(k);
              }
              if (this.sw.indexOf(k.tool[0]) != -1) {
                this.toolData[1].push(k);
              }
              if (this.xz.indexOf(k.tool[0]) != -1) {
                this.toolData[2].push(k);
              }
              if (this.cp.indexOf(k.tool[0]) != -1) {
                this.toolData[3].push(k);
              }
              if (this.pj.indexOf(k.tool[0]) != -1) {
                this.toolData[4].push(k);
              }
              if (this.bc.indexOf(k.tool[0]) != -1) {
                this.toolData[5].push(k);
              }
              if (this.xk.indexOf(k.tool[0]) != -1) {
                this.toolData[6].push(k);
              }
            }
          });
        });
      });
      // console.log("this.toolData", this.toolData);

      // 环形图占比
      this.toolRatio[0].value = this.toolData[0].length;
      this.toolRatio[1].value = this.toolData[1].length;
      this.toolRatio[2].value = this.toolData[2].length;
      this.toolRatio[3].value = this.toolData[3].length;
      this.toolRatio[4].value = this.toolData[4].length;
      this.toolRatio[5].value = this.toolData[5].length;
      this.toolRatio[6].value = this.toolData[6].length;
      this.toolRatio = this.toolRatio.filter(e => {
        return e.value != 0;
      });
      // console.log("this.toolRatio", this.toolRatio);

      this.renderChart2(); //环形

      // console.log("this.toolRatio[0]", this.toolRatio);
      // 作业提交率折线图
      let repeatWork = this.newArrFn(this.data3);
      let repeatWorkTwo = this.claNewArrFn(this.data6);

      this.getFoldLineDataAi(repeatWork, repeatWorkTwo);

      // this.getClaFoldLineDataAi(repeatWorkTwo);

      // 计算任务得分
      this.getFoldLineSCoDataAi(this.data4);
      // this.getClaFoldLineSCoDataAi(this.data5);

      // 计算分组工具使用比例
      this.getColumnDataAI();

      // 师生互动折线图
      this.getTeaStuHdAi(this.data4);
      // this.getClaTeaStuHdAi(this.data5);

      // 生生互动主动
      this.getStuInterAllWorkAi(this.data13, this.data7); // 1
      // // 生生互动被动
      //  this.getBdStuInterAllWorkAi(this.data6, this.data8);  // 2
      // this.getClaStuInterAllWorkAi(this.data13, this.data11);  // 3

      // setTimeout(() => {
      // this.initChart();    // 作业提交率折线图
      // this.initChart2(); // 阶段成绩 任务成绩
      // this.initChart3(); // 分组工具占比
      // this.initChart4(); // 师生互动折线图
      // this.initChart5(); // 学生互动主动折线图
      // this.initChart6(); // 学生互动被动折线图
      // }, 500);
    },

    // 编辑
    extCon(val) {
      // this.exitCon.splice(val, 1, false);
      this.$set(this.exitCon, val, false);
    },
    // 确定
    qutCon(val, mc) {
      // console.log("qutCon");
      // this.exitCon.splice(val, 1, true);
      this.$set(this.exitCon, val, true);

      this.AiAnalysisCon2Copy[mc] = this.AiAnalysisCon2[mc];
      this.upOneDataTeacher();
    },
    // 重新生成
    async agAnl(val, mc) {
      this.$message.info("重新生成中...");

      this.canvasLing.splice(val, 1, true);
      let realData = [
        { per: "", cla: "", nam: "zy" },
        { per: "", cla: "", nam: "zb" },
        { per: "", cla: "", nam: "shd" },
        { per: "", cla: "", nam: "sshZ" },
        { per: "", cla: "", nam: "sshB" },
        { per: "", cla: "", nam: "ach" }
      ];
      // 作业提交率
      this.stageListPer.forEach((e, index) => {
        realData[0].per += `任务${index + 1}：${e}，`;
      });
      this.classStageListPer.forEach((e, index) => {
        realData[0].cla += `任务${index + 1}：${e}，`;
      });

      // 完成任务方式占比
      this.columnData[0].data.forEach((e, index) => {
        realData[1].per += `任务${index + 1}：${e}，`;
      });
      this.columnData[1].data.forEach((e, index) => {
        realData[1].cla += `任务${index + 1}：${e}，`;
      });

      // 师生互动
      this.interactWork.forEach((e, index) => {
        realData[2].per += `任务${index + 1}：${e}，`;
      });
      this.claInteractWork.forEach((e, index) => {
        realData[2].cla += `任务${index + 1}：${e}，`;
      });

      // 生生互动（主动）
      this.stuInterAllLike.forEach((e, index) => {
        realData[3].per += `任务${index + 1}：${e.length}，`;
      });
      this.claAtuInterAllLike.forEach((e, index) => {
        realData[3].cla += `任务${index + 1}：${e}，`;
      });

      // 生生互动（被动）
      this.bdStuInterAllLike.forEach((e, index) => {
        realData[4].per += `任务${index + 1}：${e.length}，`;
      });
      this.claAtuInterAllLike.forEach((e, index) => {
        realData[4].cla += `任务${index + 1}：${e}，`;
      });

      // 任务成绩
      this.scoFoldLineData.forEach((e, index) => {
        realData[5].per += `任务${index + 1}：${e}，`;
      });
      this.claScoFoldLineData.forEach((e, index) => {
        realData[5].cla += `任务${index + 1}：${e}，`;
      });

      console.log("realData", realData);
      this.realData = realData;

      for (let i = 0; i < realData.length; i++) {
        if (realData[i].nam == mc) {
          await this.AIPdfComment(realData[i]);
          this.AiAnalysisCon2Copy.mc = this.AiAnalysisCon2.mc;
          this.upOneData();
          this.canvasLing.splice(val, 1, false);
          this.$message.success("重新生成已完成");
        }
      }
    },
    // 素养分析重新生成
    async agAnl2(val, mc) {
      this.canvasLing.splice(val, 1, true);
      let poy = "";
      this.polygonData.forEach(e => {
        poy += `${e.topic}:${e.sco}`;
      });

      let num = 0;
      let toolCopy = JSON.parse(JSON.stringify(this.toolRatio));
      toolCopy.forEach(e => {
        num += e.value * 1;
      });

      toolCopy.forEach(e => {
        e.value = (e.value / num).toFixed(2);
      });

      console.log("this.toolCopy", toolCopy);
      let txt = "";
      toolCopy.forEach(e => {
        txt += `${e.name}:${e.value * 100}%,`;
      });

      let messages = `Language:${this.getLang()}

      #上下文#
      学生进行了线上平台和线下授课相结合的混合式学习，线上平台会记录学生的学习行为，并对数据进行整理然后绘制图表，平台会对图表进行描述和分析。你是一个学生学习行为分析专家，可以借助数据和图表分析结果评估学生，输出一份学生学习行为分析报告。
      素养发展雷达图中的每个维度表示课程目标，即学生通过学习培养的素养。素养发展总览以树状图的形式从左到右分别展示了“课程标题”、“素养”、“任务评价标准”、“任务序号”和使用工具完成的作业在当前评价标准维度的“得分”。
      你可以通过学生的登录时长、学习时长、作业提交率、互动等数据评估学生的学习积极性。你可以通过学生的完成任务方式、任务成绩、工具使用情况等数据评估学生的学习效果。你可以通过素养发展雷达图和素养发展等数据评估学生素养成长情况。你可以综合给你数据对学生的学习情况进行科学的、专业的分析。

      #目标#
      你要结合参考资料中的数据和图表分析结果，对学生的学习行为进行评估，并生成一份学习分析报告。报告要按顺序输出以下几个方面，格式参考输出范例。
      1.学习概况。包含了学生【登录时长】【学习时长】【学习成绩】以及在班级中所处的排名。不需要评估，陈述数据即可。
      2.学习积极性。陈述评估结果，描述参考数据以及得出结论的过程。
      3.学习效果。陈述评估结果，描述参考数据以及得出结论的过程。
      4.学生素养成长情况。分析【素养发展雷达图】和【素养发展总览】，陈述评估结果。
      5.学生学习画像。总结以上四个步骤的结论，输出总结性词条，描绘学习者画像。
      6.个性化学习建议。结合以上五个步骤的结论，提出6条与该学生高度匹配的个性化学习建议。
      注意：不要输出无关的互动性语言，生成后不要询问。

      #参考资料#
      <登录时长：${this.loginTime}>
      <学习时长：${this.studyTime}>
      <课程得分：${this.star}/5.0>
      <学科：${this.subject.join(",")}>
      <工具使用情况：${txt}>

      <作业提交率分析：${this.AiAnalysisCon2.zy}>
      <完成方式占比分析：${this.AiAnalysisCon2.zb}>
      <师生互动分析：${this.AiAnalysisCon2.shd}>
      <生生互动（主动）分析：${this.AiAnalysisCon2.sshZ}>
      <生生互动（被动）分析：${this.AiAnalysisCon2.sshB}>
      <任务成绩分析：${this.AiAnalysisCon2.ach}>

      素养发展:${poy}

      #风格#
      专业的

      #语气#
      陈述

      #受众#
      教师、家长和教育管理者

      #输出格式#
      #学习概况
      *登录时长：【1天2小时】
      *学习时长：【1天2小时】
      *课程得分：【4.4/5.0】

      ---
      #学习积极性
      学生在课程中的登录和学习时长均位于班级前25%，表明学生具有较高的 学习参与度和时间投入。此外，频繁使用平台工具(22次)也显示了学生在 学习过程中积极利用可用资源，保持了良好的学习状态。
      学生在学习过程中表现出积极的学习态度。学生大多数任务能准时提交，虽然有1次未交和2次迟交，但整体表现较好。此外，师生和生生互动次数均高于或等于班级平均值，表明学生在学习过程中积极主动，与教师和同学保持良好的互动，显示出较强的学习动力。

      ---
      #学习效果
      学生课程得分为4.4/5.0，高于班级平均水平，说明学生在知识掌握和技能应用方面表现出色。在每个阶段任务得分上，大多数高于或等于班级平均值，证明学生每个阶段的任务都能较好的完成，最终较高水平地达成了课程学习目标(能力、知道、理解)。
      协作完成的任务占总任务的36.6%，独立完成的任务占63.3%，显示出学生既具备独立学习的能力，又能有效地与他人协作。
      学生参与了科学、数学、美术学科的学习与实践，表明在多学科领域都有所涉猎，具备全面发展的潜力。

      ---
      #学生素养发展情况
      学生在科学观念（科学）维度获得4.4分，说明学生在知识掌握和技能应用方面表现出色，该素养得到了较好的发展。在艺术表现（艺术）维度获得1.5分，说明学生在创造艺术形象、表达思想感情、展现艺术美感的实践能力上仍有发展空间。

      ---
      #学生学习画像
      *学习积极主动
      *学业表现优秀
      *独立与协作兼备

      ---
      #个性化学习建议：
      1.加强时间管理: 尽量避免任务迟交和未交情况，进一步提升学习效率。
      2.增加协作机会: 尝试更多的团队协作任务，提升协作能力和团队意识。
      3.保持积极互动: 继续保持与教师和同学的良好互动，充分利用在线学习平台的优势。
      4.拓展学习领域: 在已有学科基础上，尝试探索更多学科领域，提升综合素质。
      5.定期自我评估：定期对自己的学习成果进行自我评估，以确保学习目标与个人发展目标一致。
      6.学习策略优化：尝试不同的学习方法，如主动学习、可视化学习等，找到最适合自己的学习策略。
        `;
      let params = {
        model: "gpt-4o-2024-11-20",
        temperature: this.mode == 3 ? 0.5 : 0.1,
        max_tokens: 4096,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
        messages: [
          {
            content: messages.replaceAll("\n", " ").replaceAll("*", ""),
            role: "user"
          }
        ],
        stream: false,
        uid: this.userid,
        mind_map_question: ""
      };
      this.ajax
        .post("https://gpt4.cocorobo.cn/chat", params)
        .then(response => {
          let data = response.data.FunctionResponse;
          console.log("data", data);
          let md = new MarkdownIt();

          if (data.choices && data.choices.length && data.choices[0].message) {
            let content = data.choices[0].message.content;

            this.AiAnalysisCon2.allFx = content.replaceAll("<br>", "");

            this.AiAnalysisCon2Copy.allFx = this.AiAnalysisCon2.allFx;
          }

          // console.log("data", data);
          this.loading = false;
          this.canvasLing.splice(6, 1, false);
          this.$message.success("重新生成已完成");

          this.upOneData();
        })
        .catch(error => {
          this.canvasLing.splice(6, 1, false);

          console.log(error);
        });
    },
    // ai分析上传
    upOneData() {
      let params = [
        {
          cid: this.cid,
          uid: this.worksDialogCon.userid,
          con: JSON.stringify(this.AiAnalysisCon2Copy),
          clav: this.claV
        }
      ];
      this.ajax
        .post(this.$store.state.api + "upDateAnalysisTwo", params) //getCourseWorksReport
        .then(res => {
          let params = {
            cid: this.cid,
            uid: this.worksDialogCon.userid,
            cla: this.claV
          };
          this.ajax
            .get(this.$store.state.api + "selectStuCourseReportPdfTwo", params) //getCourseWorksReport
            .then(res => {
              this.cTime = res.data[0][0].cTime;
            })
            .catch(err => {
              console.error(err);
            });
        })
        .catch(err => {
          console.error(err);
        });
    },
    // 人工修改上传
    upOneDataTeacher() {
      let params = [
        {
          cid: this.cid,
          uid: this.worksDialogCon.userid,
          con: JSON.stringify(this.AiAnalysisCon2Copy),
          clav: this.claV
        }
      ];
      this.ajax
        .post(this.$store.state.api + "upDateAnalysisTeacher", params) //getCourseWorksReport
        .then(res => {})
        .catch(err => {
          console.error(err);
        });
    },

    // 非阶段模式

    // 获取作业提交率折线图
    getFoldLineDataAi(repeatWork, val) {
      // 阶段分类作业容器
      let repeatWorkCopy = [];
      this.stageList.forEach((e, index) => {
        repeatWorkCopy[index] = [];
      });

      // 将作业进行阶段分类
      repeatWork.forEach(e => {
        repeatWorkCopy[e.task].push(e);
      });
      // console.log("repeatWorkCopy", repeatWorkCopy);

      // 计算阶段工具作业提交率
      this.toolPercentage.forEach((e, index) => {
        repeatWorkCopy.forEach((k, kin) => {
          if (index == kin) {
            if (k.length == 0 || e.length == 0) {
              this.stageListPer[index] = 0;
            } else {
              this.stageListPer[index] = (k.length / e.length).toFixed(2);
            }
          }
        });
      });
      this.getClaFoldLineDataAi(val);
    },
    getClaFoldLineDataAi(repeatWork) {
      let repeatWorkCopy = []; //作业任务分类容器
      let allWorkNum = [];

      this.stageList.forEach((e, index) => {
        repeatWorkCopy[index] = [];
        allWorkNum[index] = 0;
      });

      // 将作业进行任务分类
      repeatWork.forEach(e => {
        repeatWorkCopy[e.task].push(e);
      });

      repeatWorkCopy.forEach((e, index) => {
        if (e.length) {
          this.classStageListPer[index] = (
            e.length /
            (this.data12[0].num * this.toolPercentage[index].length)
          ).toFixed(2);
        } else {
          this.classStageListPer[index] = 0;
        }
      });

      // this.toolPercentage.forEach((e, index) => {
      //   allWorkNum[index] = e.length * this.data12[0].num;
      // });

      // allWorkNum.forEach((e, index) => {
      //   if (repeatWorkCopy[index].length) {
      //     this.classStageListPer[index] = (
      //       repeatWorkCopy[index].length / e
      //     ).toFixed(2);
      //   } else {
      //     this.classStageListPer[index] = 0;
      //   }
      // });
      this.initChart(); // 作业提交率折线图
    },
    // 补零寻找四分位数
    padArrayWithZeros(array, targetLength, direction = "right") {
      const zeros = new Array(targetLength).fill(0);
      const paddedArray =
        direction === "right" ? array.concat(zeros) : zeros.concat(array);
      return paddedArray.slice(0, targetLength);
    },
    // 计算任务得分
    getFoldLineSCoDataAi(repeatWork) {
      // 作业数据e.sco得分
      repeatWork.forEach(e => {
        let con = Object.values(JSON.parse(e.rate));
        e.sco = 0;
        let kop = 0;

        con.forEach((i, k) => {
          if (k != con.length - 1) {
            e.sco += i * 1;
            kop++;
          }
        });
        if (e.sco == 0 || con.length == 0) {
          e.sco = 0;
        } else {
          e.sco = (e.sco / kop).toFixed(1);
        }
      });
      // console.log('repeatWork',JSON.parse(JSON.stringify(repeatWork)));

      let repeatWorkCopy = []; // 任务分类作业容器
      let scoList = []; //分数每个任务的所有任务分的集合

      this.stageList.forEach((e, index) => {
        repeatWorkCopy[index] = [];
        scoList[index] = 0;
      });

      // 将作业进行阶段分类
      repeatWork.forEach(e => {
        repeatWorkCopy[e.task].push(e);
      });

      // 获取任务下的可评分工具数量
      let toolNum = [];

      this.toolPercentage.forEach((e, i) => {
        toolNum[i] = [];
        e.forEach(k => {
          if (this.TeaStuInt.indexOf(k) != -1) {
            toolNum[i].push(k);
          }
        });
      });

      repeatWorkCopy.forEach((e, index) => {
        e.forEach(k => {
          scoList[index] += k.sco * 1;
        });
        if (scoList[index] == 0) {
          scoList[index] = 0;
        } else {
          scoList[index] = (scoList[index] / toolNum[index].length).toFixed(1);
        }
      });

      this.scoFoldLineData = scoList;

      let zSco = 0;
      this.scoFoldLineData.forEach(e => {
        zSco += e * 1;
      });

      this.star = (zSco / this.scoFoldLineData.length).toFixed(1);

      this.getClaFoldLineSCoDataAi(this.data5);
    },
    getClaFoldLineSCoDataAi(repeatWork) {
      // 作业数据e.sco得分
      repeatWork.forEach(e => {
        let con = Object.values(JSON.parse(e.rate));
        e.sco = 0;
        let kop = 0;
        con.forEach((i, k) => {
          if (k != con.length - 1) {
            e.sco += i * 1;
            kop++;
          }
        });
        if (e.sco == 0 || con.length == 0) {
          e.sco = 0;
        } else {
          e.sco = (e.sco / kop).toFixed(1);
        }
      });

      // 获取任务下的可评分工具数量
      let toolNum = [];

      this.toolPercentage.forEach((e, i) => {
        toolNum[i] = [];
        e.forEach(k => {
          if (this.TeaStuInt.indexOf(k) != -1) {
            toolNum[i].push(k);
          }
        });
      });

      let repeatWorkCopy = []; // 任务分类作业容器
      let scoList = []; //分数每个任务的所有任务分的集合
      // let blockData = []; //盒须图数据
      // this.claScoFoldLineData = []
      // let scoNum = []// 每个任务下的分数集合

      this.stageList.forEach((e, index) => {
        repeatWorkCopy[index] = [];
        scoList[index] = 0;
        // blockData[index] = []
        // scoNum[index] = []
        // this.claScoFoldLineData[index] = [0,0,0,0,0]
      });

      // 将作业进行阶段分类
      repeatWork.forEach(e => {
        repeatWorkCopy[e.task].push(e);
        // scoNum[e.task].push(e.sco * 1);
      });

      // console.log('repeatWorkCopy',JSON.parse(JSON.stringify(repeatWorkCopy)));

      // scoNum.forEach((e,i)=>{
      //   if (e.length < (toolNum[i].length * this.data12[0].num)) {
      //     e = this.padArrayWithZeros(e,(toolNum[i].length * this.data12[0].num))
      //   }
      //   e = e.sort((a, b) => a - b);
      //   console.log('scoNum',e);

      //   let sco2 = (e.length * 0.25).toFixed(0)
      //   let sco3 = (e.length * 0.75).toFixed(0)
      //   console.log(sco2,sco3);

      //   this.claScoFoldLineData[i][0] = e[0]
      //   this.claScoFoldLineData[i][1] = e[sco2]
      //   this.claScoFoldLineData[i][3] = e[sco3] //
      //   this.claScoFoldLineData[i][4] = e[e.length-1]
      // })

      repeatWorkCopy.forEach((e, index) => {
        e.forEach(k => {
          scoList[index] += k.sco * 1;
        });
        // scoList[index] //任务得分

        if (scoList[index] == 0) {
          scoList[index] = 0;
        } else {
          //所有任务得分 =  任务得分 / 人数
          scoList[index] =
            scoList[index] / (this.data12[0].num * toolNum[index].length);
        }
      });

      scoList.forEach((e, i) => {
        this.claScoFoldLineData[i] = e.toFixed(1);
      });

      // console.log('this.claScoFoldLineData',this.claScoFoldLineData);

      // this.claScoFoldLineData = scoList.map((e,i) => {
      //   if (e == 0) {
      //     return 0;
      //   } else {
      //     return (e / toolNum[i].length).toFixed(2);
      //   }
      // });

      this.initChart2(); // 班级任务成绩
    },

    // 师生互动数据
    getTeaStuHdAi(TeaStuHdData) {
      let hd = []; //分数每个任务的所有任务分的集合
      this.stageList.forEach((e, index) => {
        hd[index] = 0;
      });

      TeaStuHdData.forEach((e, i) => {
        hd[e.task]++;
      });

      this.interactWork = hd;
      this.getClaTeaStuHdAi(this.data5);
    },
    getClaTeaStuHdAi(TeaStuHdData) {
      let hd = []; //分数每个任务的所有任务分的集合
      this.stageList.forEach((e, index) => {
        hd[index] = 0;
      });

      TeaStuHdData.forEach((e, i) => {
        hd[e.task]++;
      });

      let arr = hd.map(e => {
        if (e == 0) {
          return 0;
        } else {
          return (e / this.data12[0].num).toFixed(1);
        }
      });
      // console.log("arr", arr);

      this.claInteractWork = arr;
      this.initChart4(); // 师生互动折线图
    },

    // 生生互动主动
    getStuInterAllWorkAi(val, likeData) {
      let hd = []; //分数每个任务的所有任务分的集合
      this.stageList.forEach((e, index) => {
        hd[index] = [];
      });
      hd.forEach((e, index) => {
        val.forEach(k => {
          if (k.task == index) {
            e.push(k.id);
          }
        });
      });
      hd.forEach((e, index) => {
        likeData.forEach(k => {
          if (e.indexOf(k.workId) != -1) {
            this.stuInterAllLike[index].push(k);
          }
        });
      });
      this.getBdStuInterAllWorkAi(this.data6, this.data8); // 2
    },
    // 生生互动被动
    getBdStuInterAllWorkAi(val, likeData) {
      this.bdStuInterAllWork.forEach((e, index) => {
        val.forEach(k => {
          if (k.task == index) {
            e.push(k.id);
          }
        });
      });
      this.bdStuInterAllWork.forEach((e, index) => {
        likeData.forEach(k => {
          if (e.indexOf(k.workId) != -1) {
            this.bdStuInterAllLike[index].push(k);
          }
        });
      });
      this.getClaStuInterAllWorkAi(this.data13, this.data7); // 2
    },
    getClaStuInterAllWorkAi(val, likeData) {
    // console.log('likeData',JSON.parse(JSON.stringify(likeData)));
    // console.log('val',JSON.parse(JSON.stringify(val)));
    
      let hd = []; //分数每个任务的所有任务分的集合
      this.stageList.forEach((e, index) => {
        hd[index] = [];
        this.claAtuInterAllLike[index] = 0;
      });

      hd.forEach((e, index) => {
        val.forEach(k => {
          if (k.task == index) {
            e.push(k.id);
          }
        });
      });

      hd.forEach((e, index) => {
        likeData.forEach(k => {
          if (e.indexOf(k.workId) != -1) {
            this.claAtuInterAllLike[index]++;
          }
        });
      });
      // console.log('claAtuInterAllLike',JSON.parse(JSON.stringify(this.claAtuInterAllLike)));

      this.claAtuInterAllLike = this.claAtuInterAllLike.map(e => {
        if (e == 0 || this.data12[0].num ==0) {
          return 0;
        } else {
          return (e / this.data12[0].num).toFixed(1);
        }
      });
      this.initChart5(); // 学生互动主动折线图
      this.initChart6(); // 学生互动主动折线图
    },

    // 通用方法

    // 多边形
    moreRenderChart() {
      let myChart = echarts.init(this.$refs.moreChart);

      const option = {
        radar: {
          indicator: this.polygonData.map(category => ({
            name: category.topic,
            max: 5
          }))
        },
        tooltip: {
          // formatter: "{b} : {c}"
        },
        radius: "80%",
        nameGap: 5,
        series: [
          {
            type: "radar",

            emphasis: {
              label: {
                show: true,
                fontSize: "20"
              }
            },
            data: [
              {
                value: this.polygonData.map(category => category.sco),
                name: "素养平均分"
              }
            ]
          }
        ]
      };

      myChart.setOption(option);
    },

    // 环形
    renderChart2() {
      let chartObj2 = echarts.init(this.$refs.ringChart);

      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: "2%",
          itemWidth: 10, // 控制图例项的宽度
          itemHeight: 10, // 控制图例项的高度
          data: this.toolRatio.map(item => item.name)
        },
        series: [
          {
            name: "工具占比",
            type: "pie",
            radius: ["25%", "75%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "inside",
              formatter: " {d}%"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20"
                // fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            center: ["50%", "50%"], // 控制饼图的位置

            data: this.toolRatio
          }
        ]
      };

      chartObj2.setOption(option);
    },

    // 任务成绩
    initChart2() {
      const chart = echarts.init(this.$refs.cScoEcharts);
      // let boxData =this.claScoFoldLineData;

      // let scatterData = this.scoFoldLineData;

      // console.log('boxData', boxData);
      // console.log('scatterData', scatterData);

      const option = {
        title: {
          text: "任务成绩",
          left: "left",
          textStyle: {
            color: "rgba(140, 140, 140, 1)", // 标题颜色
            fontSize: 10, // 标题字体大小
            fontWeight: "bold" // 加粗样式
          }
        },
        tooltip: {
          trigger: "axis"
          // formatter: "{b} : {c}"
        },
        legend: {
          data: ["个人数据", "班级平均值"],
          // align: "right",
          orient: "vertical", // 设置为垂直排列
          right: 10
        },
        xAxis: {
          type: "category",
          data: this.stageList.map(item => item),
          axisTick: {
            alignWithLabel: true // 使刻度线和标签对齐
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}"
          },
          max: 5
        },
        series: [
          {
            name: "个人数据",
            data: this.scoFoldLineData.map(item => item),
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              opacity: 1 // 设置透明度为1，即不透明
            }
          },
          {
            name: "班级平均值",
            data: this.claScoFoldLineData.map(item => item),
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              opacity: 1 // 设置透明度为1，即不透明
            }
          }
          // {
          //   data: this.scoFoldLineData.map(item => item),
          //   type: "line"
          // }
        ]
      };
      // let option = {
      //   title: {
      //     text: "任务成绩",
      //     left: "left",
      //     textStyle: {
      //       color: "rgba(140, 140, 140, 1)", // 标题颜色
      //       fontSize: 10, // 标题字体大小
      //       fontWeight: "bold" // 加粗样式
      //     }
      //   },
      //   legend: {
      //     data: ["个人数据", "班级数据"],
      //     // align: "right",
      //     orient:  "vertical", // 设置为垂直排列
      //     right: 10
      //   },
      //   tooltip: {
      //     trigger: "item",
      //     axisPointer: {
      //       type: "shadow",
      //     },
      //   },
      //   xAxis: [
      //     {
      //       type: "category",
      //       data: this.stageList.map(item => item),
      //     },

      //   ],
      //   yAxis: [
      //     {
      //       type: "value",
      //       max: 5
      //     },
      //   ],
      //   series: [
      //     {
      //       name: "班级数据",
      //       type: "boxplot",
      //       data: boxData,
      //     },
      //     {
      //       name: "个人数据",
      //       type: "scatter",
      //       data: scatterData,
      //       itemStyle: {
      //         color: function (params) {
      //           // 获取当前散点的 X 轴值
      //           let xValue = params.value[0];
      //           // 获取相应 X 轴位置的盒须图数据的最小值
      //           let boxMinValue = boxData[xValue][1];
      //           let boxMinValue2 = boxData[xValue][3];

      //           // 判断散点是否低于盒须图的最小值，低于的话显示红色
      //           if (params.value[1] < boxMinValue) {
      //             return "red";
      //           } else if( params.value[1] >= boxMinValue2 ){
      //             return "green";
      //           }else{
      //             return "yellow";
      //           }
      //         },
      //       },
      //     },
      //   ],
      // };

      chart.setOption(option);

      // window.onresize = () => {
      //   jm.resize();
      // };
    },
    // 分组工具占比
    initChart3() {
      const chart = echarts.init(this.$refs.groupingEcharts);

      const option = {
        title: {
          text: "完成任务方式占比",
          left: "left",
          textStyle: {
            color: "rgba(140, 140, 140, 1)", // 标题颜色
            fontSize: 10, // 标题字体大小
            fontWeight: "bold" // 加粗样式
          }
        },
        legend: {
          data: this.columnData.map(item => item.name), // 设置图例的数据为系列的名称
          orient: "vertical", // 设置为垂直排列
          right: 10
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var res = "";
            for (var i = 0, l = params.length; i < l; i++) {
              if (i == 0) {
                res += params[i].name + "<br/>";
              }
              res += params[i].seriesName + ": " + params[i].value + "%<br/>";
            }
            return res;
          }
        },
        xAxis: {
          type: "category",
          data: this.stageList.map(item => item)
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}%"
          },
          max: 100
        },
        series: this.columnData.map(item => ({
          name: item.name,
          type: "bar",
          stack: "total",
          barWidth: "60%",
          label: {
            show: true,
            formatter: params => Math.round(params.value) + "%"
          },
          data: item.data
        }))
      };

      chart.setOption(option);
    },
    // 师生互动折线图
    initChart4() {
      const chart = echarts.init(this.$refs.interactionEcharts);

      const option = {
        title: {
          text: "师生互动",
          left: "left",
          textStyle: {
            color: "rgba(140, 140, 140, 1)", // 标题颜色
            fontSize: 10, // 标题字体大小
            fontWeight: "bold" // 加粗样式
          }
        },
        tooltip: {
          trigger: "axis"
          // formatter: "{b} : {c}"
        },
        legend: {
          data: ["个人数据", "班级平均值"],
          // align: "right",
          orient: "vertical", // 设置为垂直排列
          right: 10
        },
        xAxis: {
          type: "category",
          data: this.stageList.map(item => item),
          axisTick: {
            alignWithLabel: true // 使刻度线和标签对齐
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}"
          }
        },
        series: [
          {
            name: "个人数据",
            data: this.interactWork.map(item => item),
            type: "line",
            symbol: "circle",
            symbolSize: 5
          },
          {
            name: "班级平均值",
            data: this.claInteractWork.map(item => item),
            type: "line",
            symbol: "circle",
            symbolSize: 5
          }
        ]
      };

      chart.setOption(option);
    },
    // 学生互动主动折线图
    initChart5() {
      const chart = echarts.init(this.$refs.stuInteractZdEcharts);

      const option = {
        title: {
          text: "生生互动（主动）",
          left: "left",
          textStyle: {
            color: "rgba(140, 140, 140, 1)", // 标题颜色
            fontSize: 10, // 标题字体大小
            fontWeight: "bold" // 加粗样式
          }
        },
        legend: {
          data: ["个人数据", "班级平均值"],
          // align: "right",
          orient: "vertical", // 设置为垂直排列
          right: 10
        },
        tooltip: {
          trigger: "axis"
          // formatter: "{b} : {c}"
        },
        xAxis: {
          type: "category",
          data: this.stageList.map(item => item),
          axisTick: {
            alignWithLabel: true // 使刻度线和标签对齐
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}"
          }
        },
        series: [
          {
            name: "个人数据",
            data: this.stuInterAllLike.map(item => item.length),
            type: "line",
            symbol: "circle",
            symbolSize: 5
          },
          {
            name: "班级平均值",
            data: this.claAtuInterAllLike.map(item => item),
            type: "line",
            symbol: "circle",
            symbolSize: 5
          }
        ]
      };

      chart.setOption(option);
    },
    // 学生互动被动折线图
    initChart6() {
      const chart = echarts.init(this.$refs.bdStuInteractZdEcharts);

      const option = {
        title: {
          text: "生生互动（被动）",
          left: "left",
          textStyle: {
            color: "rgba(140, 140, 140, 1)", // 标题颜色
            fontSize: 10, // 标题字体大小
            fontWeight: "bold" // 加粗样式
          }
        },
        tooltip: {
          trigger: "axis"
          // formatter: "{b} : {c}"
        },
        legend: {
          data: ["个人数据", "班级平均值"],
          // align: "right",
          orient: "vertical", // 设置为垂直排列
          right: 10
        },
        xAxis: {
          type: "category",
          data: this.stageList.map(item => item),
          axisTick: {
            alignWithLabel: true // 使刻度线和标签对齐
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}"
          }
        },
        series: [
          {
            name: "个人数据",
            data: this.bdStuInterAllLike.map(item => item.length),
            type: "line",
            symbol: "circle",
            symbolSize: 5
          },
          {
            name: "班级平均值",
            data: this.claAtuInterAllLike.map(item => item),
            type: "line",
            symbol: "circle",
            symbolSize: 5
          }
        ]
      };

      chart.setOption(option);
    },
    // 作业提交率折线图
    initChart() {
      const chart = echarts.init(this.$refs.toolSubEcharts);

      const option = {
        title: {
          text: "作业提交率",
          left: "left",
          textStyle: {
            color: "rgba(140, 140, 140, 1)", // 标题颜色
            fontSize: 10, // 标题字体大小
            fontWeight: "bold" // 加粗样式
          }
        },
        legend: {
          data: ["个人数据", "班级平均值"],
          // align: "right",
          orient: "vertical", // 设置为垂直排列
          right: 10
        },
        xAxis: {
          type: "category",
          data: this.stageList.map(item => item),
          axisTick: {
            alignWithLabel: true // 使刻度线和标签对齐
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var res = "";
            for (var i = 0, l = params.length; i < l; i++) {
              if (i == 0) {
                res += params[i].name + "<br/>";
              }
              res += params[i].seriesName + ": " + params[i].value + "%<br/>";
            }
            return res;
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}%"
          },
          max: 100
        },
        series: [
          {
            name: "个人数据",
            data: this.stageListPer.map(item => item * 100),
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              opacity: 1 // 设置透明度为1，即不透明
            }
          },
          {
            name: "班级平均值",
            data: this.classStageListPer.map(item => item * 100),
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              opacity: 1 // 设置透明度为1，即不透明
            }
          }
        ]
      };

      chart.setOption(option);
    },
    // 计算分组工具使用比例Ai(添加)
    getColumnDataAI() {
      let repeatWork = this.newArrFn(this.data3);

      let columnDataCopy = [];
      let columnDataCopyTwo = [];

      // 阶段下每个任务（任务下每个工具）作业分类
      let repeatWorkCopy = [];

      this.stageList.forEach((e, index) => {
        repeatWorkCopy[index] = [];
      });

      // 将作业进行阶段分类
      repeatWork.forEach(e => {
        repeatWorkCopy[e.task].push(e);
      });

      // console.log("repeatWorkCopy", JSON.parse(JSON.stringify(repeatWorkCopy)));

      repeatWorkCopy.forEach((e, index) => {
        if (e && e.length) {
          columnDataCopy[index] =
            e.filter(item => item.type === 11).length / e.length;
        } else {
          columnDataCopy[index] = 0;
        }
        columnDataCopyTwo[index] = 1 - columnDataCopy[index];
      });

      columnDataCopy = columnDataCopy.map(function(item, index, arr) {
        return item * 100;
      });
      columnDataCopyTwo = columnDataCopyTwo.map(function(item, index, arr) {
        return item * 100;
      });

      this.columnData[0].data = columnDataCopyTwo;
      this.columnData[1].data = columnDataCopy;

      this.initChart3(); // 分组工具占比
    },

    // 通用方法

    // 清空数据
    clearData() {
      //ai数据分析
      this.AiAnalysisCon2 = {
        zy: "", //作业提交
        zb: "", //完成方式占比
        shd: "", //师生互动
        sshZ: "", //生生互动主动
        sshB: "", //生生互动被动
        ach: "", //任务成绩
        allFx: "" //学习分析
      };
      this.AiAnalysisCon2Copy = "";
      this.subject = [];
      this.toolRatio = [
        { name: "互动类", value: 0 },
        { name: "思维类", value: 0 },
        { name: "协作类", value: 0 },
        { name: "测评类", value: 0 },
        { name: "评价类", value: 0 },
        { name: "编程类", value: 0 },
        { name: "学科类", value: 0 }
      ];
      this.stageList = [];
      this.toolPercentage = []; // 每个任务有的工具
      this.stageListPer = []; // 作业提交率基础数据折线图
      this.classStageListPer = [];

      // 课程阶段下互动数据工具
      this.interact = [];

      this.interactWork = []; //每个工具下提交的作业

      this.stuInterAllLike = []; // 生生互动阶段点赞评论分类

      this.bdStuInterAllWork = []; // 生生互动阶段被动作业分类
      this.bdStuInterAllLike = []; // 生生互动阶段被动点赞评论分类
    },
    // 查看图片
    previewImg(url) {
      this.$hevueImgPreview(url);
    },
    // 去重
    claNewArrFn(arr) {
      // 创建一个新的空数组
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        // 设置一个开关，如果是true，就存进去，不是就不存
        let flag = true;
        for (let j = 0; j < newArr.length; j++) {
          // 原数组和新数组作比较，如果一致，开关变为 false
          if (
            arr[i].stage == newArr[j].stage &&
            arr[i].task == newArr[j].task &&
            arr[i].tool == newArr[j].tool &&
            arr[i].userid == newArr[j].userid
          ) {
            flag = false;
          }
        }
        flag ? newArr.push(arr[i]) : newArr;
      }
      return newArr;
    },
    // 去重
    tarArrFn(arr) {
      // 创建一个新的空数组
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        // 设置一个开关，如果是true，就存进去，不是就不存
        let flag = true;
        for (let j = 0; j < newArr.length; j++) {
          // 原数组和新数组作比较，如果一致，开关变为 false
          if (arr[i].target == newArr[j].topic) {
            flag = false;
          }
        }
        flag
          ? newArr.push({ id: `nod${i}`, topic: arr[i].target, children: [] })
          : newArr;
      }
      return newArr;
    },
    // 计算分组工具使用比例
    getColumnData() {
      let repeatWork = this.newArrFn(this.data3);

      let columnDataCopy = [];
      let columnDataCopyTwo = [];

      // 作业分类
      let repeatWorkCopy = [];

      this.stageList.forEach((e, index) => {
        repeatWorkCopy[index] = [];
      });

      // 将作业进行阶段分类
      repeatWork.forEach(e => {
        repeatWorkCopy[e.stage].push(e);
      });

      repeatWorkCopy.forEach((e, index) => {
        if (e && e.length) {
          columnDataCopy[index] =
            e.filter(item => item.type === 11).length / e.length;
        } else {
          columnDataCopy[index] = 0;
        }
        columnDataCopyTwo[index] = 1 - columnDataCopy[index];
      });

      columnDataCopy = columnDataCopy.map(function(item, index, arr) {
        return item * 100;
      });
      columnDataCopyTwo = columnDataCopyTwo.map(function(item, index, arr) {
        return item * 100;
      });

      this.columnData[0].data = columnDataCopyTwo;
      this.columnData[1].data = columnDataCopy;
    },
    // 计算时长
    secondsToDhms(seconds) {
      const days = Math.floor(seconds / (3600 * 24));
      const hours = Math.floor((seconds % (3600 * 24)) / 3600);

      return days + " 天 " + hours + " 时";
    },
    // 判断一个工具下是否提交多个作,有重复的只取一个
    newArrFn(arr) {
      // 创建一个新的空数组
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        // 设置一个开关，如果是true，就存进去，不是就不存
        let flag = true;
        for (let j = 0; j < newArr.length; j++) {
          // 原数组和新数组作比较，如果一致，开关变为 false
          if (
            arr[i].stage == newArr[j].stage &&
            arr[i].task == newArr[j].task &&
            arr[i].tool == newArr[j].tool
          ) {
            flag = false;
          }
        }
        flag ? newArr.push(arr[i]) : newArr;
      }
      return newArr;
    },
    handleClose(done) {
      done();
    }
  }
};
</script>

<style scoped>
.pbl {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: auto;
  background-color: #f3f7fd;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* padding: 20px; */
  /* padding-top: 10px; */
  overflow: auto;
  border-radius: 10px;
  position: relative;
}
.pbl >>> .el-loading-spinner {
  top: 500px !important;
}
.zxt >>> .el-loading-spinner {
  top: 50% !important;
}
.pdfCon {
  width: 220mm;
  margin: auto;
  position: relative;
}
.pageTit {
  width: 100%;
  text-align: left;
  font-size: 28px;
  padding: 10px 0;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}
.full_diy {
  min-width: 1200px !important;
}
.full_diy >>> .el-dialog {
  height: 80%;
  width: 598px !important;
  margin-top: 10vh !important;
  display: flex;
  flex-direction: column;
}
.full_diy >>> .el-dialog__body {
  overflow: auto;
  flex: 1;
  padding: 0 !important;
}
.full_diy >>> .el-dialog__title {
  color: #fff !important;
}
.full_diy >>> .el-dialog__header {
  padding: 9px 20px 10px;
  background: #32455b !important;
}
.coverPage {
  /* height: 840pt; */
  padding: 150px 8% 0;
  box-sizing: border-box;
  background-color: #ccc;
  position: relative;
  background-image: url("../../../assets/icon/exportPdfworks/bcg1.svg"),
    url("../../../assets/icon/exportPdfworks/bcg2.svg");
  /* 设置每个背景的位置和尺寸，可以使用关键字或者具体的像素值，用逗号分隔 */
  background-position: top left, bottom;
  background-size: 225px, contain;

  /* 设置每个背景图片的重复方式，用逗号分隔 */
  background-repeat: no-repeat, no-repeat;
  position: relative;
}
.AiBtn {
  position: absolute;
  top: 20px;
  left: 25px;
  z-index: 5;
}
.coverPageLogo {
  position: absolute;
  top: 30px;
  right: 6%;
}

.coverPageFrom {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  margin: 0 auto;
}
.coverPageFromTit {
  display: flex;
  justify-content: center;
  width: 100%;
}
.fromCss {
  border: 1.5px dashed rgba(158, 208, 255, 1);
  border-radius: 16px;
  background-color: #fff;
  padding: 40px 32px;
  width: 77%;
  font-family: PingFang SC;
  margin: 8px 0;
  color: rgba(35, 99, 205, 1);
}
.fromCss > div {
  margin-bottom: 28px;
  display: flex;
}
.fromCss > div > span {
  flex-shrink: 0;
  margin-right: 5px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(92, 80, 70, 1);
}
.fromCss > div:last-child {
  margin-bottom: 0;
}
.txt {
  width: 100%;
  border-bottom: 1px solid rgba(192, 210, 229, 1);
  text-align: center;
  color: #000;
  height: 30px;
}
.txt >>> .el-select {
  width: 100%;
  height: 100%;
}
.txt >>> .el-input__icon {
  line-height: 0;
}
.txt >>> .el-select > .el-input {
  height: 100%;
}
.txt >>> .el-input--suffix .el-input__inner {
  text-align: center;
  color: #000;
  height: 100%;
  border: none;
}
.coverPageCon {
  background-color: #e3edfe;
  display: flex;
  flex-direction: column;
  padding: 0 60px;
  padding-bottom: 100px;
  box-sizing: border-box;
  font-family: PingFang SC;
}
.zhBlock {
  width: 48%;
  height: 42%;
  padding: 9px 12px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.zhBlockTit {
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.zhBlockCon {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  font-weight: 400;
  background-color: rgba(243, 247, 253, 1);
  border-radius: 5px;
}
.zhBlockCon >>> .el-rate__icon {
  margin: 0 !important;
}
.zhBlockCon2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* flex-wrap: wrap; */
  flex: 1;
  overflow: hidden;
}
.zhBlockCon2 > div {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  flex: 1;
}
.zhBlockCon2 > div > span {
  font-size: 9px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  background-color: rgba(243, 247, 253, 1);
  border-radius: 2px;
  padding: 0px 8px;
  height: 15px;
  line-height: 15px;
  box-sizing: border-box;
  margin-right: 4px;
  margin-bottom: 2px;
}
.zxt {
  min-height: 330px;
  width: 100%;
  border: 1px solid #ccc;
  margin: 10px 0;
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 25px;
  border-radius: 15px;
  box-sizing: border-box;
}
.zxtTxt {
  background-color: rgba(243, 247, 253, 1);
  padding: 15px 25px 40px;
  box-sizing: border-box;
  border-radius: 10px;
  min-height: 300px;
  position: relative;
}
.zxtTxt:hover .zxtBtn {
  display: block;
}
.zxtBtn {
  display: none;
  text-align: right;
  color: #5470c6;
  margin-top: 10px;
  position: absolute;
  right: 10px;
  bottom: 5px;
}
.zxtBtn span {
  cursor: pointer;
  margin-left: 10px;
}
.zxt >>> .el-textarea__inner {
  min-height: 300px !important;
}
.pdfAnalysis {
  width: 100%;
}
.pdfAnalysisCon {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 15px;
  line-height: 25px;
}
.termC {
  margin: 30px auto 45px;
  font-size: 18px;
  color: rgba(92, 80, 70, 1);
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.termC > div > span {
  color: rgba(176, 123, 0, 1);
  border-bottom: 2px solid rgba(242, 228, 213, 1);
  padding: 3px 10px;
  margin: 0 8px;
}
.suy {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0;
}

/* .coverPageCon {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
} */

.stageCon {
  background-color: #fff;
  padding: 0px 60px 100px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 8px;
  width: 100%;
}

.a_addBox {
  margin: 10px 0;
  background: #fff;
  padding: 0 15px;
  /* max-height: 400px; */
  /* max-height: 160px; */
  /* overflow: auto; */
}
.redioStyle >>> .el-radio__label {
  font-size: 18px;
}

.redioStyle5 >>> .el-radio__label {
  font-size: 14px;
  color: #06a7ff !important;
}
.redioStyle2 >>> .el-radio__label {
  font-size: 14px;
}

.redioStyle3 >>> .el-checkbox__label {
  font-size: 14px;
  color: #06a7ff !important;
}
.redioStyle4 >>> .el-checkbox__label {
  font-size: 14px;
}
.WorksCon >>> .el-checkbox-group {
  margin: 0 5px;
}
.sortTool {
  padding: 1px 3px;
  border: 2px #5d89c4 solid;
  margin: 0 5px;
  min-width: 20px;
  border-radius: 5px;
  text-align: center;
}
/* table 样式 */
.cont >>> table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.cont >>> table td,
.cont >>> table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 15px 5px;
  max-width: 0px;
}

.cont >>> table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
.taskSco {
  background-color: rgba(243, 247, 253, 1);
  border-radius: 8px;
  padding: 8px;
  box-sizing: border-box;
  margin: 8px 0;
}
.score_boxTit > span {
  border-left: 3px solid rgba(54, 129, 252, 1);
  padding-left: 5px;
}
.score_boxTit {
  /* padding: 0 30px; */
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}
.inImg {
  width: 100px;
}
.inImg > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.radioBox {
  display: flex;
  flex-direction: column;
}
.WorksCon >>> .el-radio {
  display: flex;
  align-items: center;
  margin: 5px;
}
.WorksCon >>> .el-checkbox {
  display: flex;
  align-items: center;
  margin: 5px;
}
.RootImgBlock {
  width: 50%;
  font-size: 12px;
}
.score_box {
  display: flex;
  align-items: center;
  font-size: 14px !important;
  /* justify-content: flex-start; */
  justify-content: space-between;
  margin-bottom: 15px;
  /* margin: 10px 0 0 30px; */
  margin: 5px 0;
  position: relative;
}
.score_box:last-child {
  margin-bottom: 0;
}
.worksTarget {
  border-left: 3px solid rgba(54, 129, 252, 1);
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}
.worksTarget > span {
  margin-left: 5px;
}
.worksTargetCon {
  background-color: #fff;
  padding: 10px;
  margin-top: 10px;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 12px;
}
.worksTargetCon > div {
  margin-bottom: 10px;
}
.worksTargetCon > div:last-child {
  margin: 0 !important;
}
.dialog_diy >>> .el-dialog__header {
  padding: 9px 20px 10px;
  background: #32455b !important;
}
.worksDialogCSS >>> .el-dialog__header {
  /* padding: 9px 20px 10px; */
  background: #32455b !important;
}

.worksDialogCSS >>> .el-dialog__body {
  width: 643px !important;
}
.worksDialogCSS >>> .el-dialog {
  width: 683px !important;
}
.stageTit {
  text-align: left;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 20px;
  color: #605449;
  /* border-left: 5px 605449 solid; */
  padding-left: 5px;
}
.taskTitInd {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.taskTitInd span:nth-child(1) {
  background-color: rgba(242, 161, 75, 1);
  color: #fff;
  padding: 3px 5px;
  border-radius: 4px;
  margin-right: 5px;
  box-sizing: border-box;
  font-size: 12px;
}
.taskTitInd div {
  background-color: rgba(242, 161, 75, 1);
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}
.taskTitInd span:nth-child(2) {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 600;
}
.taskBri {
  background-color: rgba(253, 247, 243, 1);
  padding: 10px 12px;
  line-height: 20px;
  box-sizing: border-box;
  font-weight: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
}
.toolBlk {
  display: flex;
  height: 44px;
  margin: 15px 0;
}
.toolBlk img {
  height: 100%;
  margin-right: 8px;
}
.toolTit {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.toolTit div:nth-child(1) {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: rgba(0, 0, 0, 0.9);
  margin-right: 10px;
}
.toolTit div:nth-child(2) {
  font-family: PingFang SC;
  font-size: 11px;
  font-weight: 400;
  text-align: left;
  color: rgba(0, 0, 0, 0.9);
}
.answerTxt {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  line-height: 30px;
  padding: 0 10px;
}
.taskSco {
  background-color: rgba(253, 247, 243, 1);
  border-radius: 8px;
  padding: 10px 15px;
  box-sizing: border-box;
  margin: 8px 0;
  width: 100%;
}
.taskScoTit {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px;
}
.taskScoTit div:nth-child(1) {
  color: rgba(0, 0, 0, 0.9);
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.taskScoTit div:nth-child(2) {
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
}
.taskScoCon {
  display: flex;
  justify-content: space-between;
}

.taskScoConTit {
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.9);
  border-left: 5px rgba(242, 161, 75, 1) solid;
  padding-left: 5px;
}
.WorkCon {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: PingFang SC;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  flex: 1;
}
.WorkConSY {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  flex: 1;
}
.WorkConSY div {
  margin-bottom: 8px;
}
.WorkConSY div:last-child {
  margin-bottom: 0;
}
.RootImgBlockSy {
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
}
.termC {
  margin: 30px auto;
  font-size: 22px;
  color: rgba(92, 80, 70, 1);
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.termC > div > span {
  color: rgba(176, 123, 0, 1);
  border-bottom: 2px solid rgba(242, 228, 213, 1);
  padding: 3px 10px;
  margin: 0 8px;
}
.taskCon {
  margin-bottom: 15px;
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/components/exportDataDialog.vue